import { injectPersonalData } from '../pages/impressum/impressumUtils.js';

const baseTranslationES = {
  title: 'Aviso legal',
  subtitle: 'Información conforme al § 5 de la DDG (ley alemana de servicios digitales)',
  serviceProvider: 'Prestador de servicios',
  contactTitle: 'Contacto',
  addressLabel: 'Dirección',
  contactLabel: 'Dirección de correo electrónico',
  professionalTitle: 'Datos de la empresa',
  professionLabel: 'Forma jurídica',
  businessTypeLabel: 'Tipo de actividad',
  taxTitle: 'Datos fiscales',
  liabilityTitle: 'Aviso sobre responsabilidad',
  contentLiabilityTitle: 'Responsabilidad por los contenidos',
  contentLiability: 'Como prestadores de servicios, somos responsables de los contenidos propios de estas páginas conforme al § 7, apdo. 1, de la DDG y a la legislación general. No obstante, según los §§ 8 a 10 de la DDG, como prestadores de servicios no estamos obligados a supervisar la información ajena transmitida o almacenada ni a investigar circunstancias que apunten a una actividad ilícita.',
  linkLiabilityTitle: 'Responsabilidad por los enlaces',
  linkLiability: 'Nuestra oferta contiene enlaces a sitios web externos de terceros sobre cuyos contenidos no tenemos influencia alguna. Por ello, no podemos asumir ninguna garantía respecto a esos contenidos ajenos. El responsable de los contenidos de las páginas enlazadas es siempre el respectivo proveedor u operador de dichas páginas. Las páginas enlazadas se revisaron en el momento de establecer el enlace para detectar posibles infracciones legales. En ese momento no se apreciaban contenidos ilícitos.',
  copyrightTitle: 'Derechos de autor',
  copyright: 'Los contenidos y las obras creados por los operadores del sitio en estas páginas están sujetos a la legislación alemana sobre derechos de autor. La reproducción, la adaptación, la distribución y cualquier tipo de explotación fuera de los límites del derecho de autor requieren el consentimiento por escrito del autor o creador correspondiente. Las descargas y copias de este sitio solo están permitidas para uso privado y no comercial.'
};

export const localeES = {
  nav: {
    title: 'pAIoneer Labs GmbH',
    home: 'Inicio',
    team: 'Equipo',
    events: 'Eventos',
    finance: 'IA financiera',
    teaching: 'Formación',
    agenticdev: 'IDD / Agentic Coding',
    iddLegacy: 'Modernizar software heredado',
    iddMethod: 'Intent-Driven Development',
    veridion: 'Veridion',
    kyveil: 'Anonimización',
    quantum: 'IA cuántica',
    login: 'Iniciar sesión',
    openApp: 'Abrir aplicación',
    account: 'Cuenta',
    admin: 'Admin',
    logout: 'Cerrar sesión',
    languageNames: {
      en: 'Inglés',
      de: 'Alemán',
      nl: 'Neerlandés',
      uk: 'Ucraniano',
      fr: 'Francés',
      it: 'Italiano',
      es: 'Español',
      sv: 'Sueco',
      fi: 'Finés',
      ja: 'Japonés',
      pl: 'Polaco',
      bg: 'Búlgaro'
    }
  },
  admin: {
    datalake: {
      loading: "Cargando …",
      loadFailed: "El data lake no está accesible",
      refresh: "Actualizar",
      generatedAt: "Estado a",
      notRolled: "Esta área aún no está desplegada en el backend. En cuanto los nuevos endpoints estén en línea, aquí aparecerá el estado medido.",
      loadMore: "Cargar más",
      yes: "sí",
      no: "no",
      none: "ninguno",
      close: "Cerrar",
      summaryTitle: "Dos hipótesis, un banco de trabajo",
      summaryBody: "La hipótesis de la arquitectura dice: el recipiente matemático decide en qué puede convertirse el modelo — vive en la página del paper LLM. La hipótesis de los datos dice: solo datos de entrenamiento enlazados y verificados llenan ese recipiente — esta página la sirve. El autopiloto llena el patrimonio de datos de forma continua, inicia el entrenamiento en cuanto se alcanza el plan de datos del paper en cada área, en alemán y en inglés, mide el resultado con la suite de benchmarks y publica el modelo en privado en HuggingFace. Cada cifra aquí está medida o marcada como valor configurado.",
      summaryArchButton: "A la hipótesis de la arquitectura (paper LLM)",
      apTitle: "Autopiloto",
      tpTitle: "Camino hacia el inicio del entrenamiento",
      tpSubtitle: "Dónde está el piloto automático ahora: cada paso hasta el entrenamiento en marcha, con estado, tiempo y progreso.",
      tpNow: "Ahora",
      tpStep: "Paso",
      tpOf: "de",
      tpSince: "desde",
      tpFor: "en marcha desde hace",
      tpHeartbeat: "última señal de vida",
      tpDone: "hecho",
      tpRunning: "en marcha",
      tpWaiting: "en espera",
      tpFailed: "fallido",
      tpSkipped: "omitido",
      tpProgress: "Progreso",
      tpRows: "filas",
      tpRate: "por segundo",
      tpRemaining: "tiempo restante estimado",
      tpEstimateNote: "estimación a partir de los contadores medidos",
      tpPhaseReading: "leyendo un paquete de datos",
      tpPhaseAdmission: "admisión (duplicados, entropía)",
      tpPhaseEncoding: "tokenización",
      tpNoTiming: "Esta versión del motor aún no informa tiempos.",
      tpBlockers: "Bloqueos y errores",
      tpNone: "Sin bloqueos.",
      trTitle: "Ejecución de entrenamiento (en vivo)",
      trSubtitle: "Leído directamente del directorio de la ejecución del entrenador: funciona también mientras el worker se reinicia.",
      trNoRun: "Todavía no hay ninguna ejecución de entrenamiento con datos de progreso.",
      trStateTraining: "entrenando",
      trStateStarting: "iniciando",
      trStateFinished: "terminado",
      trStateSilent: "en silencio desde hace {age}",
      trStep: "Paso",
      trOf: "de",
      trRemaining: "Tiempo restante (estimación a partir de la velocidad medida)",
      trSecondsPerStep: "s por paso",
      trProgress: "Progreso de los pasos planificados",
      trRun: "Ejecución",
      trResumed: "reanudada en el paso {step}",
      trVersion: "Versión de los datos de entrenamiento",
      trModel: "Modelo",
      trTokensPerSecond: "Tokens/s",
      trTokensSeen: "Tokens vistos",
      trVram: "Memoria de GPU",
      trCap: "límite",
      trLastHeartbeat: "Último heartbeat",
      trAgo: "hace {age}",
      trShardReads: "Lecturas de shards locales / a través del worker",
      trLossTitle: "Evolución de la pérdida (loss)",
      trLossTotal: "Total",
      trLossNtp: "Siguiente token",
      trLossMtp: "Multitoken",
      trChartEmpty: "Todavía no se han notificado pasos.",
      trAxisNote: "Horizontal: paso de entrenamiento; vertical: pérdida (logaritmo natural). Pase el ratón sobre la curva para ver los valores de un paso.",
      trValue: "Valor",
      trCurrentValue: "actual",
      trPoints: "{count} puntos de medición en total",
      trStages: "Etapas del currículo",
      trStageFoundation: "Base (texto en bruto)",
      trStageCapability: "Capacidades",
      trStageAnneal: "Anneal",
      trStageCurrent: "en curso",
      trStageDone: "terminada",
      trStageAhead: "pendiente",
      trShards: "shards",
      trRows: "filas",
      trCheckpoint: "Checkpoint más reciente",
      trCheckpointNone: "todavía ninguno",
      trCheckpoints: "Checkpoints completos en disco",
      trCheckpointEvery: "cada {minutes} min",
      trKernels: "Kernels activos",
      trDeviations: "Desviaciones",
      trBlockStorage: "Copia en el block storage",
      trBlockStorageNone: "todavía ninguna: la primera llega tras el primer checkpoint",
      trUploading: "subiendo: paso {step}",
      treeCkRun: "Ejecución de entrenamiento",
      treeCkCopy: "Checkpoint en el block storage, copiado {time}",
      treeCkLocal: "Checkpoint en el disco del servidor",
      treeCkUploading: "se está copiando al block storage",
      trKpiProgress: "Progreso",
      trKpiTokens: "Tokens",
      trKpiThroughput: "Rendimiento",
      trKpiLoss: "Pérdida",
      trKpiLr: "Tasa de aprendizaje",
      trKpiGpu: "Memoria de GPU",
      trEndAt: "fin aprox. {time}",
      trSeenPlanned: "vistos / planificados",
      trBest: "mejor {value}",
      trHourAgo: "{value} frente a hace 1 h",
      trPerplexity: "perplejidad {value}",
      trPhaseWarmup: "calentamiento",
      trPhaseCosine: "descenso coseno",
      trPhaseStable: "fase estable",
      trPhaseDecay: "enfriamiento",
      trKpiEpoch: "Época",
      trEpochValue: "{epoch} de {epochs}",
      trPlanTitle: "Plan de entrenamiento",
      trPlanExplain: "Calentamiento hasta la tasa de aprendizaje máxima, luego constante durante cuatro épocas mezcladas del corpus; la fase de enfriamiento entrena con la mezcla de mayor calidad (muestras de capacidad, textos de libro de texto, anneal) y baja la tasa de aprendizaje a cero.",
      trPlanPhase: "Fase",
      trPlanStableSteps: "Pasos planificados de la fase estable",
      trPlanDecay: "Enfriamiento",
      trPlanDecayAhead: "desde el paso {step} · en unos {time}",
      trPlanDecayAheadNoTime: "desde el paso {step}",
      trPlanDecayRunning: "desde el paso {step} · {steps} pasos hasta tasa de aprendizaje cero",
      trPlanTokensPerStep: "Tokens por paso de optimización",
      trPlanTokensPerStepValue: "{tokens} ({accum} microlotes)",
      trPlanRecompute: "Recálculo de activaciones",
      trPlanRecomputeOn: "activado – medido más rápido con un microlote mayor",
      trPlanRecomputeOff: "desactivado – medido más rápido sin él",
      trPlanFim: "Documentos en formato fill-in-the-middle hasta ahora",
      tbTitle: "Programa de libros de texto",
      tbSubtitle: "Textos de foundation reescritos por modelos maestros como texto de libro de texto; cada número y cada nombre propio debe aparecer en la fuente.",
      tbTokens: "Tokens de libro de texto",
      tbTokensSub: "{pct} % del objetivo de {target}",
      tbSamples: "Reescrituras admitidas",
      tbJobs: "Trabajos terminados",
      tbTeacher: "Tokens del maestro por token de libro de texto",
      tbCost: "Coste por millón de tokens de libro de texto",
      tbCostNone: "la pasarela no informa costes; se cuentan los tokens del maestro",
      tbExplain: "Se ejecuta junto al entrenamiento; las épocas posteriores y el enfriamiento leen lo que esté sellado para entonces.",
      trThroughputTitle: "Rendimiento (tokens/s)",
      trCurriculumTitle: "Currículo",
      trStageTokens: "{tokens} tokens",
      trStageBegins: "empieza en el paso {step}",
      trPlanWarningLabel: "Atención",
      trPlanWarning: "La ejecución termina tras {max} pasos en la etapa «{stage}»: los datos de capacidades solo empiezan en el paso {cap}. Una pasada completa requeriría {steps} pasos (≈ {days} días).",
      trPlanOk: "Los pasos planificados llegan hasta la etapa «{stage}».",
      trCheckpointsTitle: "Checkpoints",
      trNextCheckpoint: "Próximo checkpoint",
      trInSpan: "en {span}",
      trResumes: "Reanudación",
      trNoResume: "ninguna",
      trConfig: "Configuración",
      trHealth: "Estado",
      trMicroBatch: "Microlote / tokens por paso",
      trSeqLen: "Longitud de secuencia",
      trLrPlan: "Plan de la tasa de aprendizaje",
      trLrPlanValue: "pico {lr}, calentamiento {warmup} pasos, coseno hasta el paso {max}",
      trSpikes: "Picos de pérdida (última hora)",
      trProgressSub: "paso {step} de {max} · entrenando desde hace {elapsed}",
      trTokensSub: "de {planned} planificados",
      trPathTrainingDetail: "{pct} % · paso {step} de {max} · fin aprox. {end}",
      trReadinessRunning: "El entrenamiento está en marcha: {pct} % hecho (paso {step} de {max}), pérdida {loss}, fin aprox. {end}.",
      tdvDraftsHistory: "Borradores antiguos, nunca sellados ({count})",
      runsHistory: "Ejecuciones interrumpidas y fallidas ({count})",
      trAxisStep: "Paso de entrenamiento",
      trAxisLoss: "Pérdida (logaritmo natural)",
      trCountdown: "{d} d {h} h {m} min {s} s",
      trTimerWaiting: "El temporizador aparece tras las primeras mediciones.",
      trTimerStageEnds: "La etapa «{stage}» termina en",
      trTimerAt: "a las {time}",
      trTimerNext: "Después «{stage}»: {span}, desde {time}",
      trTimerRunEnds: "La ejecución termina en {span} (a las {time})",
      trStepTimeSub: "{wall} s por paso medidos · cómputo {compute} s",
      trEtaTitle: "Tiempo restante según la duración medida del paso",
      trEtaEpochEnds: "La época {epoch} de {epochs} termina en",
      trEtaEpochAt: "a las {time} (paso {step})",
      trEtaNextEpoch: "Época {epoch}: desde {time} (paso {step})",
      trEtaDecay: "La fase de enfriamiento comienza en {span} (a las {time}, paso {step})",
      trEtaBasis: "Base: {wall} s por paso, media de los últimos {n} pasos sin {pauses} pausas (relanzamiento, parada); tiempo de cómputo según el entrenador {compute} s por paso.",
      devTitle: "Desviaciones respecto al plano",
      devNone: "Sin desviaciones: la ejecución sigue el plano por completo.",
      devPlanned: "planificado",
      devLimit: "limitación",
      devSeqLen: "Longitud de contexto",
      devSeqLenText: "Entrena con {trained} tokens de contexto en lugar de los {spec} previstos en el plano. El contexto largo llega en una fase posterior.",
      devFim: "Relleno de huecos (FIM)",
      devFimText: "El objetivo de relleno de huecos ({rate} % de los bloques) está declarado en el plano pero aún no está activo en esta ejecución.",
      devTermination: "Sonda de terminación",
      devTerminationText: "La sonda de terminación no es un objetivo de entrenamiento, sino un modo propio posterior; se ejecuta después sobre un checkpoint terminado.",
      devDecision: "Objetivo de decisión",
      devDecisionText: "El objetivo de decisión está activo, pero en las etapas posteriores de esta ejecución no llegaron marcas de decisión.",
      devKernelOff: "Aceleración desactivada",
      devKernelUnverifiedText: "El kernel «{kernel}» no fue verificado por la sonda y se ejecuta como cálculo estándar.",
      devKernelUnavailableText: "El kernel «{kernel}» no está disponible en esta tarjeta y se ejecuta como cálculo estándar.",
      devKernelFellBackText: "El kernel «{kernel}» volvió al cálculo estándar durante la ejecución ({reason}).",
      devOptimizer: "Optimizador",
      devOptimizerText: "Los estados del optimizador van en bfloat16 en lugar de 8 bits (bitsandbytes no disponible): más memoria, misma matemática.",
      devScale: "Tamaño del modelo",
      devScaleText: "El modelo se instancia al {scale} % del tamaño del plano porque el tamaño completo no cabía en la memoria medida.",
      devMediaHeads: "Cabezas de medios",
      devMediaHeadsText: "Las cabezas de imagen/audio están sin entrenar porque los datos no contienen tokens de medios; previsto para una línea de texto.",
      devVision: "Ruta de visión",
      devVisionText: "La ruta de visión está construida pero entrenó con cero imágenes porque los datos no contienen ninguna.",
      devOther: "Otro",
      trStageShare: "{pct} % de esta etapa completado",
      cap_tool_calling: "Llamadas a herramientas",
      cap_deep_reasoning: "Razonamiento profundo",
      cap_software_engineering: "Desarrollo de software",
      cap_office_finance: "Oficina y finanzas",
      cap_doc_understanding: "Comprensión de documentos",
      tpExplainThresholds: "Para cada capacidad de la línea elegida deben existir suficientes ejemplos verificados en el data lake. Objetivo y medición aparecen aquí por capacidad.",
      tpThresholdsDetail: "{met} de {total} capacidades han alcanzado su objetivo",
      tpThresholdRow: "{measured} ejemplos",
      tpForeignThresholds: "No para esta línea: {list} — pertenece a otra línea y no bloquea nada.",
      tpStepTokenizerReleaseExplain: "El tokenizador convierte texto en números. Se fija una vez y se comunica a la arquitectura para que datos y modelo hablen el mismo idioma.",
      tpStepTokenizeTdvExplain: "Todos los ejemplos verificados se traducen a secuencias numéricas con el tokenizador fijado.",
      tpStepTokenizeCorpusExplain: "Todo el texto en bruto del data lake se traduce a secuencias numéricas: la masa para la base.",
      tpStepTdvCreateExplain: "Con todos los datos tokenizados se compone una versión fija de datos de entrenamiento (TDV), con currículo y cantidad de tokens medida.",
      tpStepTdvSealExplain: "La versión se vuelve inmutable y se copia con su descripción al block storage.",
      tpStepCompatExplain: "Doce reglas comprueban que versión y arquitectura encajan (tokenizador, longitud de contexto, objetivos, memoria). Todas deben estar en verde.",
      tpStepVramExplain: "Mide en la tarjeta si hay suficiente memoria de GPU libre para la necesidad declarada.",
      tpVramDetail: "{free} GB libres, {need} GB necesarios",
      tpStepTrainStartExplain: "El piloto automático inicia la ejecución en cuanto se cumplen todas las condiciones.",
      tpStepTrainingExplain: "La ejecución entrena de forma autónoma con checkpoints cada 30 minutos y continúa sola tras cualquier interrupción. Detalles en la página «Entrenamiento y publicación».",
      tpVramRunning: "tarjeta ocupada por el entrenamiento en curso ({need} GB necesarios); cumplido al inicio",
      trPathTrainingDetailNoEnd: "{pct} % · paso {step} de {max}",
      srTitle: "Preparación de datos por línea de modelo",
      srSubtitle: "Mientras una línea entrena, el data lake sigue preparando los datos de las demás, hasta su propia versión sellada, sin inicio de entrenamiento.",
      srTrainingNow: "entrenando ahora",
      srSelected: "seleccionada",
      srDataReady: "datos listos",
      srPreparing: "en preparación",
      srModalities: "entrada: {in} · salida: {out}",
      srThresholds: "objetivos: {met} de {total} alcanzados",
      srCorpus: "Corpus tokenizado",
      srCorpusValue: "{tokens} tokens en {shards} paquetes de datos",
      srVersion: "Versión más reciente",
      srNoVersion: "todavía ninguna",
      srLacking: "Falta aún",
      srLacksNothing: "nada: la versión espera a su línea",
      srLackThresholds: "objetivos no alcanzados",
      srLackCodec: "códec de imagen/audio no liberado",
      srLackTokenizer: "tokenizador no comunicado",
      srLackVersion: "sin versión sellada",
      srSelectedNote: "Esta línea entrena ahora; su camino está arriba.",
      srSelectedIdleNote: "Esta línea está seleccionada para el próximo entrenamiento; su camino está arriba.",
      srUnselectedNote: "Esta línea no inicia entrenamiento mientras otra esté seleccionada; aun así sus datos se preparan por completo.",
      modText: "texto",
      modImage: "imagen",
      modAudio: "audio",
      modVideo: "vídeo",
      tpStepThresholds: "Alcanzar los objetivos",
      tpStepPlan: "Alcanzar el plan de datos del paper",
      tpExplainPlan: "El paper fija cuántos tokens únicos y verificados necesita cada área. El alemán y el inglés aportan cada uno al menos la mitad; el código cuenta sin idioma. Se cuentan los tokens admitidos tras eliminar duplicados, no la estimación bruta.",
      tpPlanDetail: "{met} de {total} áreas alcanzadas",
      tpPlanRowLang: "{have} / {target} · alemán {de} / {half} · inglés {en} / {half}",
      tpPlanRowFree: "{have} / {target}",
      tpPlanOpen: "abierto: {langs}",
      tpLangDe: "alemán",
      tpLangEn: "inglés",
      tpPlanProvisional: "Contado provisionalmente con el tokenizador anterior; decide el recién entrenado.",
      tpStepOwnTokenizer: "Tokenizador propio de la línea",
      tpStepOwnTokenizerExplain: "La línea se entrena con un tokenizador propio, aprendido sobre un corpus equilibrado que incluye código. Solo en sus tokens cuenta el plan de datos de forma definitiva.",
      tpPlanCat_knowledge: "Conocimiento",
      tpPlanCat_code: "Código",
      tpPlanCat_mathematics: "Matemáticas",
      tpPlanCat_domain: "Textos especializados",
      tpPlanCat_textbook: "Libro de texto",
      tpPlanCat_agentic: "Muestras agénticas",
      tpPlanFlow: "entrada {rate} por hora",
      tpPlanEtaDays: "faltan unos {n} días",
      tpPlanEtaHours: "faltan unas {n} horas",
      tpPlanNoFlow: "sin entrada en las últimas 24 horas",
      tpPlanBinding: "cuello de botella",
      tpBind_download: "descarga",
      tpBind_allowance: "la cuota diaria del block storage",
      tpBind_ingest: "ingesta",
      tpBind_teachers: "modelos maestros",
      thrPlanTitle: "Muestras por capacidad (medidas)",
      thrPlanNote: "Los objetivos de esta línea los fija su paper: el plan de datos por área, en alemán y en inglés, en el camino al inicio del entrenamiento. Los umbrales por capacidad solo valen para líneas sin plan de datos; aquí figura lo que contiene cada capacidad según la medición.",
      thrPlanRow: "{samples} muestras · {tokens} tokens",
      srDataPlan: "Plan de datos del paper: {met} de {total} áreas alcanzadas",
      srLackDataPlan: "plan de datos no alcanzado",
      srPlanOpen: "abierto: {areas}",
      tpBind_source: "ninguna fuente en este idioma",
      tpBind_paused: "descarga en pausa",
      tdvPlanEmpty: "Aún no hay versión de datos de la especificación activa. El autopiloto la construye y la sella en cuanto se alcanza el plan de datos del paper.",
      compatPlanNone: "Aún no hay comprobación: la versión de la especificación activa se comprueba cuando se sella.",
      mixPlanTitle: "Mezcla según el paper",
      mixPlanNote: "Cada paso de entrenamiento toma las áreas en estas proporciones fijas; la fase de decaimiento eleva la parte de alta calidad hasta la mitad. Los objetivos de mezcla por capacidad solo valen para líneas sin plan de datos.",
      mixPlanShare: "{area} {pct} %",
      sitTitle: "Situación",
      sitSubtitle: "Dónde está el entrenamiento de un vistazo: lo que aún falta en cada área del paper, lo que está en marcha y lo que viene después.",
      sitHeadlineDays: "El entrenamiento puede empezar como pronto en unos {time}; lo que más tarda es {area} (cuello de botella: {bottleneck}).",
      sitHeadlineBlocked: "Así no se alcanza el plan de datos: {items} no tiene fuente. Se está trabajando en ello: buscar conjuntos abiertos o traducir con comprobación.",
      sitHeadlineReached: "El plan de datos está alcanzado; siguen el tokenizador, la nueva tokenización, el sellado y las comprobaciones.",
      sitHeadlineUnknown: "La entrada del resto aún no está medida.",
      sitHold: "Además, el inicio está detenido hasta que se verifique cada componente.",
      sitArea: "Área",
      sitTotal: "Total",
      sitFlow: "Entrada",
      sitLeft: "Falta",
      sitBottleneck: "Cuello de botella",
      sitNoLanguage: "sin idioma",
      sitNoSource: "sin fuente",
      sitReached: "alcanzado",
      sitDays: "{n} días",
      sitHours: "{n} h",
      sitPerHour: "{value} por hora",
      sitPerHourTokens: "{value} tokens por hora",
      sitRunningTitle: "Lo que está en marcha",
      sitDownloads: "Descargas",
      sitIngest: "Procesamiento en fragmentos de texto",
      sitTokenize: "Tokenización",
      sitGenerate: "Generación por modelos maestros",
      sitIdle: "en reposo",
      sitNextTitle: "Lo que viene después",
      sitNextSteps: "Entrenar el tokenizador con código → volver a tokenizar todo el corpus → sellar la versión → comprobaciones → inicio del entrenamiento",
      sitProvisional: "Las cantidades se cuentan provisionalmente con el tokenizador anterior; el recién entrenado cuenta definitivamente.",
      tpPlanSeeSituation: "Áreas, idiomas y tiempos restantes están en la situación de arriba.",
      sitHeadlineBlocks: "El entrenamiento aún no puede empezar: faltan componentes que todavía hay que construir ({items}). Mientras tanto, los datos crecen.",
      sitDuration: "Duración del entrenamiento: unos {days} días para {budget} tokens a los {rate} tokens por segundo medidos en la misma red.",
      sitBlocksTitle: "Componentes del entrenamiento",
      sitStateNotBuilt: "aún no construido",
      sitStateWaiting: "espera",
      sitStateReady: "listo",
      sitBlockWaitsFor: "espera: {items}",
      sitBenchProgress: "{made} de {total} tareas verificadas",
      sitBlockParts: "construido: {built} · pendiente: {open}",
      part_graph_bundles: "documentos enlazados",
      part_repository_bundles: "repositorios completos",
      part_long_context: "contexto largo",
      part_fine_tuning: "ajuste fino",
      part_reinforcement_learning: "aprendizaje por refuerzo",
      part_real_folding: "plegado real del contexto",
      sitBlock_data: "Datos según el plan del paper",
      sitBlock_tokenizer: "Tokenizador con código",
      sitBlock_bench: "Suite de benchmarks del paper",
      sitBlock_trainer: "Entrenador: etapas de ventana, presupuesto fijo, mezcla fija",
      sitBlock_bundles: "Paquetes: documentos enlazados y repositorios completos",
      sitBlock_post_training: "Post-entrenamiento: contexto largo, ajuste fino, aprendizaje por recompensa",
      tpStepTokenizerRelease: "Liberación del tokenizador",
      tpStepTokenizeTdv: "Tokenizar los ejemplos de entrenamiento",
      tpStepTokenizeCorpus: "Tokenizar el corpus",
      tpStepTdvCreate: "Crear la versión de datos",
      tpStepTdvSeal: "Sellar la versión de datos",
      apAfterSealLabel: "Continuar automáticamente tras el sellado",
      apAfterSealOn: "ON",
      apAfterSealOff: "OFF",
      apAfterSealConfirmOn: "¿Continuar automáticamente tras el sellado? El camino hacia el inicio del entrenamiento sigue sin pausa: comprobación de compatibilidad, comprobaciones de GPU e inicio del entrenamiento.",
      apAfterSealConfirmOff: "¿Volver a detenerse tras el sellado? El piloto automático se pausa entonces para revisión una vez sellada la versión de datos.",
      apAfterSealTurnedOn: "El camino hacia el inicio del entrenamiento continúa automáticamente tras el sellado.",
      apAfterSealTurnedOff: "El piloto automático se detiene tras el sellado.",
      apAfterSealWaiting: "Versión de datos sellada: el piloto automático está en pausa para revisión.",
      apAfterSealStep: "Revisión de la versión de datos sellada",
      apAfterSealHint: "Tras el sellado todos los datos están procesados en el almacenamiento de bloques. Con el interruptor apagado, el piloto automático se pausa allí para revisión; encendido, el camino continúa automáticamente.",
      tpStepCompat: "Comprobación de compatibilidad",
      tpStepVram: "Prueba de VRAM",
      tpStepTrainStart: "Inicio del entrenamiento",
      tpStepTraining: "Entrenamiento en marcha",
      apSubtitle: "Un interruptor para todo el ciclo: reunir, procesar y enlazar datos, generar ejemplos, entrenar en cuanto se alcanza el plan de datos del paper, medir con benchmarks y publicar en privado. Cada bloqueo se nombra en lugar de ocultarse.",
      apOn: "Autopiloto ACTIVADO",
      apOff: "Autopiloto DESACTIVADO",
      apTurnOn: "Activar el autopiloto",
      apTurnOff: "Desactivar el autopiloto",
      apConfirmOn: "¿Activar el piloto automático? Completa los datos de forma continua hasta la versión de datos sellada; después se pausa para revisión, salvo que «Continuar automáticamente tras el sellado» esté activado.",
      apConfirmOff: "¿Desactivar el autopiloto? El trabajo en curso termina de forma controlada; nada se descarta.",
      apEnabled: "Autopiloto activado",
      apDisabled: "Autopiloto desactivado",
      apPause: "Pausar",
      apResume: "Reanudar",
      apResumed: "Autopiloto reanudado",
      apPausedNote: "Autopiloto en pausa",
      apPausedPill: "en pausa",
      apPhaseLabel: "Fase",
      apPhaseSince: "desde {time}",
      apCycleId: "Ciclo",
      apBlockedLabel: "Bloqueado",
      apCycleTitle: "Progreso del ciclo en curso",
      apCycleEmpty: "Ningún ciclo activo.",
      colPhase: "Fase",
      colPending: "Pendiente",
      colRunning: "En curso",
      colDone: "Terminado",
      colFailed: "Fallido",
      thrTitle: "Umbrales por capacidad",
      thrSubtitle: "A partir de estos volúmenes el autopiloto sella una versión de datos de entrenamiento e inicia el entrenamiento; las barras muestran el progreso medido.",
      thrMet: "alcanzado",
      thrNotMet: "abierto",
      thrDefault: "valor predeterminado inicial",
      thrForeign: 'no para la línea elegida',
      staleSince: 'El worker no responde ahora mismo — último estado medido de',
      staleHint: 'El piloto automático sigue funcionando; la vista se actualiza en cuanto el worker vuelva a responder.',
      idxTitle: 'Índice vectorial y deduplicación',
      idxSubtitle: 'El índice HNSW propio del lago para el enlace del grafo y la eliminación medida de shards de chunks duplicados.',
      idxConfigured: 'Índice configurado',
      idxReachable: 'Índice accesible',
      idxPoints: 'Puntos del índice',
      idxBackfill: 'Relleno desde la tabla de embeddings',
      idxBackfillDone: 'completado',
      idxBackfillOpen: 'en curso / abierto',
      ddLastPass: 'Última pasada de deduplicación',
      ddChecked: 'activos comprobados',
      ddDropped: 'shards duplicados eliminados',
      ddRows: 'filas de chunks eliminadas',
      ddRemaining: 'candidatos restantes',
      ddNone: 'aún sin pasada',
      gsTitle: 'Etapas del grafo',
      gsSubtitle: 'Las etapas teacher del grafo — embedding y extracción de afirmaciones — sirven a la síntesis de ejemplos derivada del grafo; por eso toman los chunks en anchura a través de los activos, en orden de rango: rango 0 los documentos del propietario y las importaciones de herramientas, rango 1 la masa de saber experto (ciencia, ingeniería, libros, razonamiento, German Commons, Wikipedia), rango 2 el texto general (Wikisource, Gutenberg, corpus web, transcripciones), rango 3 el código (solo embedding, nunca extracción de afirmaciones). La masa base llega al corpus de tokens sin una pasada teacher.',
      gsMeasuredAt: 'Medido a las',
      gsRanksTitle: 'Orden de rangos',
      gsRanksEmpty: 'Aún no se ha informado ningún plan de rangos.',
      gsColRank: 'Rango',
      gsColLabel: 'Clase de fuente',
      gsColSources: 'Fuentes',
      gsColAssets: 'Activos',
      gsColPendingExtract: 'Extracción pendiente',
      gsColPendingEmbed: 'Embedding pendiente',
      gsRankOwner: 'Documentos del propietario e importaciones de herramientas',
      gsRankExpert: 'Masa de saber experto',
      gsRankGeneral: 'Texto general',
      gsRankCode: 'Código (solo embedding)',
      gsRankShort: 'rango {n}',
      gsLoopsTitle: 'Última ronda de cada bucle',
      gsColLoop: 'Bucle',
      gsColSource: 'Fuente',
      gsColChunks: 'Chunks procesados',
      gsColClaims: 'Afirmaciones',
      gsColEdges: 'Aristas',
      gsColSeconds: 'Segundos',
      gsColLast: 'Última ronda',
      gsLoopEmbed: 'Embedding',
      gsLoopExtract: 'Extracción de afirmaciones',
      gsLoopLink: 'Enlace',
      gsUngrounded: '{n} sin fundamento',
      gsNoRound: 'aún sin ronda',
      gsClaims: 'Afirmaciones en total',
      gsAssetsWithClaims: 'Activos con afirmaciones',
      gsDangling: 'Nodos de chunk huérfanos',
      gsStuck: 'Activos atascados (en proceso sin ingesta activa)',
      gsConcurrency: 'Paralelismo de la extracción',
      gsOrphansLast: 'Última pasada de limpieza',
      gsOrphansNone: 'aún sin pasada',
      gsOrphansStatusCleaned: 'limpiado',
      gsOrphansDropped: 'nodos eliminados',
      gsOrphansRemaining: 'restantes',
      gsOrphansHint: 'Nada que hacer aquí: el piloto automático planifica por sí mismo una pasada de limpieza acotada mientras existan nodos de chunk sin shard. El resumen muestra la última pasada.',
      thrSamplesBar: "Ejemplos",
      thrTokensBar: "Tokens (estimados)",
      thrNoMinimum: "medido, sin mínimo",
      thrEditTitle: "Editar umbrales",
      thrEditSubtitle: "Guardar sustituye todos los umbrales por completo; los valores predeterminados iniciales solo rigen hasta que aquí se fijen valores propios.",
      thrMinSamples: "Ejemplos mín.",
      thrMinTokens: "Tokens mín. (estimados)",
      thrEnabled: "activo",
      thrAdd: "Añadir fila",
      thrSave: "Guardar umbrales",
      thrSaved: "Umbrales guardados",
      thrEmpty: "Aún no hay umbrales definidos — sin umbrales activos el autopiloto no sella nada y lo informa como bloqueo.",
      capability: "Capacidad",
      modSignature: "Firma",
      removeRow: "Quitar",
      budgetsTitle: "Presupuestos diarios",
      budgetsSubtitle: "Consumo contra límite por ámbito y día — los presupuestos acotan las llamadas de maestro y de embedding.",
      budgetScope: "Ámbito",
      budgetDay: "Día",
      budgetSpent: "Consumido",
      budgetCap: "Límite",
      budgetsEmpty: "No se han comunicado presupuestos.",
      eventsTitle: "Eventos",
      eventsSubtitle: "Lo último que el autopiloto hizo o comunicó, lo más reciente primero.",
      eventsEmpty: "Aún no hay eventos.",
      storageTitle: "Almacenamiento en la nube",
      storageSubtitle: "La conexión con Block Storage y la inicialización de la estructura de carpetas — repetible sin efectos secundarios.",
      connect: "Conectar Block Storage",
      backendLabel: "Backend del almacenamiento frío",
      backendBlockStorage: "Block Storage",
      backendLocal: "Almacenamiento local",
      connectedLabel: "Conexión",
      connectedYes: "conectado",
      connectedNo: "no conectado",
      accountLabel: "Cuenta",
      signinValidUntil: "Inicio de sesión válido hasta",
      oauthClientLabel: "Cliente OAuth",
      clientConfigured: "configurado",
      clientNotConfigured: "no configurado",
      bootstrapRun: "Inicializar estructura",
      bootstrapDone: "Inicialización ejecutada",
      bootstrapReportTitle: "Última ejecución",
      bootstrapNoRun: "En esta sesión aún no se ha ejecutado ningún bootstrap.",
      bootstrapLine: "Carpetas creadas: {folders} · archivos en el almacenamiento en frío: {files} · repetición sin cambios: {idempotent}",
      treeTitle: "Árbol de carpetas",
      treeSubtitle: "El árbol es una especificación versionada: aquí usted define carpetas, el autopiloto solo puede añadir. Las carpetas del motor protegidas y las carpetas no vacías las rechaza el motor con motivo. En el Block Storage solo se borra según reglas fijas, por ejemplo las copias de checkpoint más antiguas (las dos más recientes se quedan); durante una descarga completa, los borrados y sobrescrituras esperan a que termine.",
      treeActiveVersion: "Versión activa v{version}",
      treePath: "Ruta",
      treePurpose: "Propósito",
      treeCreatedBy: "Creado por",
      treeShards: "Shards",
      treeBytes: "Tamaño",
      treeActions: "Acciones",
      treeRetire: "Retirar",
      treeRetired: "Carpeta retirada",
      treeAddFolder: "Añadir carpeta",
      treeFolderAdded: "Carpeta creada",
      treeVersionsTitle: "Versiones",
      treeEmpty: "Aún no hay carpetas definidas.",
      treePlanned: "Planificado — especificación del árbol v{version}",
      treeFiles: "Archivos",
      treeSizesMeasured: "Tamaños medidos {measured}; las carpetas que el catálogo no registra se contaron por última vez en el Block Storage {walked}. 1 GB = 10⁹ bytes.",
      treeSizesNoWalk: "Tamaños medidos {measured}; las carpetas que el catálogo no registra aún no se han contado. 1 GB = 10⁹ bytes.",
      treeExpand: "Mostrar {count} subcarpetas",
      treeCollapse: "Ocultar subcarpetas",
      treeShowMore: "Mostrar {count} carpetas más",
      treeSourceCatalog: "Del catálogo: se cuentan los objetos que realmente están en el Block Storage",
      treeSourceWalk: "Contado en el recorrido por el Block Storage",
      bsUsageTitle: "Espacio del Block Storage",
      bsUsageSubtitle: "Espacio ocupado, límite y espacio libre de la cuenta de Block Storage y la parte del data lake; los valores tienen como máximo diez minutos. 1 GB = 10⁹ bytes.",
      bsUsed: "Ocupado",
      bsLimit: "Límite",
      bsFree: "Libre",
      bsNoLimit: "sin límite fijo",
      bsTrash: "En la papelera",
      bsLake: "De ello, data lake",
      bsLakeLine: "{size} en {files} archivos · {share} del espacio ocupado",
      bsMeasuredAt: "Medido",
      bsNotConnected: "El Block Storage no está conectado; el espacio aparece en cuanto haya conexión.",
      bsBarLake: "Data lake",
      bsBarOther: "Resto de la cuenta",
      bsDlTitle: "Descarga completa",
      bsDlSubtitle: "Descarga todo el Block Storage archivo por archivo en la misma estructura de carpetas, sin comprimirlo. Mientras está en curso rige el modo de protección: los borrados y sobrescrituras de los archivos registrados esperan a que termine; los archivos nuevos se siguen escribiendo y no forman parte de esta descarga. Un entrenamiento en curso nunca se retrasa.",
      bsDlButton: "Descargar todo el Block Storage",
      bsDlFolderHint: "Usted elige una vez una carpeta de destino; allí se crean las subcarpetas. Los archivos ya completos se omiten, los interrumpidos continúan desde su longitud.",
      bsDlScriptHint: "Este navegador no puede escribir carpetas. Recibe un script de descarga que crea la misma estructura de carpetas y descarga cada archivo de forma reanudable.",
      bsDlWindowsNames: "Los caracteres que Windows no permite en los nombres (como «>») aparecen en la carpeta de destino como código %, por ejemplo %3E.",
      bsDlActiveNote: "Hay una descarga en curso desde {time}. El botón de arriba la continúa en este navegador; los archivos completos se omiten.",
      bsDlBuilding: "Se está creando la lista de archivos: hasta ahora {files} archivos, {size}.",
      bsDlManifest: "Cargando la lista de archivos: {done} de {total} entradas.",
      bsDlFolder: "Carpeta de destino",
      bsDlFiles: "Archivos",
      bsDlData: "Datos",
      bsDlOf: "{done} de {total}",
      bsDlRate: "Velocidad",
      bsDlEta: "Tiempo restante",
      bsDlEtaUnknown: "calculando",
      bsDlCurrent: "Descargando ahora",
      bsDlSkipped: "{count} ya completos, omitidos",
      bsDlFailed: "{count} archivos fallidos",
      bsDlPausedNote: "En pausa. Al continuar, los archivos empezados siguen desde su longitud; el modo de protección se mantiene mientras esta página esté abierta.",
      bsDlPause: "Pausar",
      bsDlContinue: "Continuar",
      bsDlRetryFailed: "Volver a descargar los fallidos",
      bsDlFinish: "Finalizar",
      bsDlStop: "Detener",
      bsDlStateBuilding: "preparando la lista de archivos",
      bsDlStateRunning: "descargando",
      bsDlStatePaused: "en pausa",
      bsDlStateIncomplete: "incompleta",
      bsDlStateScript: "script listo",
      bsDlStateFinished: "finalizada",
      bsDlStateStopped: "terminada",
      bsDlStateActive: "activa",
      bsDlFinished: "Los {files} archivos ({size}) están en la carpeta de destino; la descarga ha finalizado.",
      bsDlFinishedNote: "La descarga ha finalizado; los borrados y sobrescrituras retenidos se ejecutan ahora.",
      bsDlStopped: "La descarga se ha detenido; los borrados y sobrescrituras retenidos se ejecutan ahora. Los archivos ya descargados se conservan.",
      bsDlEnded: "El servidor terminó la descarga, por ejemplo tras treinta minutos sin señal de vida. Un nuevo clic la vuelve a iniciar; los archivos completos se omiten.",
      bsDlSession: "La sesión ha caducado. Inicie sesión de nuevo; después, el botón de arriba continúa la descarga.",
      bsDlDiskFull: "La carpeta de destino no tiene más espacio. Libere espacio y continúe.",
      bsDlPickFailed: "No se pudo abrir la carpeta de destino.",
      bsDlScriptPosix: "Script para Linux y macOS",
      bsDlScriptWindows: "Script para Windows",
      bsDlScriptRun: "Guarde el script en la carpeta de destino e inícielo allí: en Windows con doble clic en el archivo .cmd o desde el símbolo del sistema, en Linux y macOS en un terminal con «sh <archivo>».",
      bsDlScriptKeyValid: "La clave del script es válida hasta {time}, solo para esta descarga y solo para lectura.",
      bsDlScriptHeartbeat: "Mientras esta página esté abierta, comunica al servidor que la descarga sigue en curso. Cuando el script termine, haga clic en «Finalizar».",
      bsDlProtection: "Modo de protección",
      bsDlProtectionState: "Estado",
      bsDlProtectionOn: "activo desde {time}",
      bsDlProtectionOff: "inactivo",
      bsDlScope: "Alcance de la descarga",
      bsDlScopeValue: "{files} archivos, {size}",
      bsDlDeferredDeletes: "Borrados retenidos",
      bsDlDeferredOverwrites: "Sobrescrituras retenidas",
      bsDlAddedSince: "Añadidos desde el inicio",
      bsDlLastActivity: "Última señal de vida",
      acqTitle: "Fuentes de datos",
      acqSubtitle: "Fuentes seleccionadas con licencia abierta: por fuente, la licencia, la evaluación de protección de datos, el idioma, la modalidad, el objetivo en bytes y el progreso medido. Las fuentes desactivadas nombran su motivo en lugar de faltar en silencio.",
      acqGdprNote: "Principio RGPD: los datos de entrenamiento solo se admiten de fuentes con licencia abierta y evaluación documentada de protección de datos; los datos de la bandeja pasan una limpieza de PII antes de crear ejemplos (el contador «limpiados de PII» lo muestra).",
      acqSource: "Fuente",
      acqModality: "Modalidad · idioma",
      acqLicense: "Licencia",
      acqProtection: "Protección de datos",
      acqProgress: "Progreso",
      acqDocs: "{count} archivos/objetos recibidos",
      acqTargetReached: "objetivo alcanzado",
      acqExhausted: "fuente agotada (el listado ya no entrega nada más)",
      acqEnabledPill: "activa",
      acqWaitingBuffer: "en espera: búfer lleno, la subida se pone al día",
      acqDisabledPill: "desactivada",
      acqEnable: "Activar",
      acqDisable: "Desactivar",
      acqEnabledMsg: "Fuente activada",
      acqDisabledMsg: "Fuente desactivada",
      acqTargetLabel: "Objetivo (GB)",
      acqSetTarget: "Guardar objetivo",
      acqTargetSaved: "Objetivo guardado",
      acqEmpty: "Aún no hay fuentes registradas.",
      balanceTitle: "Equilibrio lingüístico alemán/inglés",
      balanceSubtitle: "Bytes descargados por modalidad e idioma — en las fuentes iniciales el alemán no debe quedar por detrás del inglés.",
      balanceEmpty: "Aún no hay mediciones.",
      modText: "Texto",
      modAudio: "Audio",
      modImage: "Imagen",
      modVideo: "Vídeo",
      prepTitle: "Preprocesamiento",
      prepSubtitle: "Etapas del pipeline contadas, del documento bruto registrado al ejemplo de entrenamiento — cada cifra viene del catálogo; los fallos y lo no compatible se nombran.",
      prepRegistered: "registrados",
      prepScrubbed: "limpiados de PII",
      prepChunked: "troceados",
      prepEmbedded: "con embedding",
      prepExtracted: "extraídos",
      prepLinked: "enlazados",
      prepSamples: "ejemplos",
      prepByLang: "Por idioma",
      prepUnsupported: "No compatible",
      prepAwaiting: "Esperando una etapa",
      prepFailures: "Fallos",
      inboxTitle: "Bandeja de datos brutos",
      assetWhat: "Contenido",
      assetFromSource: "de la fuente {source}",
      assetFromUpload: "subido manualmente",
      mediaParquet: "Datos tabulares (Parquet)",
      treeShardsHint: "Los shards son los paquetes de datos Parquet del catálogo: cada fila es un paquete con origen, idioma y propósito — la columna «propósito» dice qué contiene una carpeta.",
      mediaWords: {
        text: "Texto",
        audio: "Audio",
        video: "Vídeo",
        image: "Imagen",
        application: "Archivo",
      },
      inboxSubtitle: "Entregar datos brutos propios al lake: subir aquí o depositar directamente en la carpeta en la nube raw/inbox/. La conciliación registra cada archivo; «Procesar ahora» inicia el mismo camino que el autopiloto recorre por sí solo.",
      uploadButton: "Subir archivo",
      uploadHint: "Hasta 512 MB por archivo. Lo subido llega al almacenamiento en frío y, al procesarse, se trocea, se convierte en embeddings y se enlaza en el grafo de conocimiento.",
      uploadTooLarge: "El archivo supera los 512 MB.",
      uploadDone: "Archivo aceptado",
      processNow: "Procesar ahora",
      processStarted: "Procesamiento iniciado",
      reconcileNow: "Conciliar carpeta en la nube",
      reconcileDone: "Conciliación ejecutada",
      unprocessedCount: "{count} sin procesar",
      inboxEmpty: "La bandeja está vacía.",
      assetName: "Archivo",
      assetType: "Tipo",
      assetSize: "Tamaño",
      assetState: "Estado",
      assetLang: "Idioma",
      assetRegistered: "Registrado",
      assetStates: {
        raw_stored: "datos brutos guardados",
        awaiting_stt: "espera reconocimiento de voz",
        awaiting_content_fetch: "esperando el contenido detrás de la dirección",
        awaiting_image_codec: "espera el códec de imagen",
        awaiting_audio_codec: "espera el códec de audio",
        awaiting_video_codec: "espera el códec de vídeo",
        chunked: "troceado y en el grafo",
        processed: "procesado",
        registered: "registrado",
        queued: "en espera",
        processing: "en procesamiento",
        ingested: "incorporado",
        linked: "enlazado",
        unsupported: "no compatible",
        failed: "fallido",
      },
      graphTitle: "Grafo de conocimiento",
      graphSubtitle: "El corpus bruto enlazado: nodos y aristas contados desde el catálogo — de estas conexiones nacen los ejemplos de entrenamiento.",
      graphEmbedded: "Nodos con embedding",
      graphModel: "Modelo de embedding",
      graphClusters: "Clústeres",
      graphAssetsLinked: "Datos brutos enlazados",
      graphLastLink: "Último enlace",
      graphNodesTitle: "Nodos por tipo",
      graphEdgesTitle: "Aristas por tipo",
      graphEmpty: "El grafo aún está vacío — nace con el primer archivo procesado.",
      kindCol: "Tipo",
      countCol: "Cantidad",
      neighborsTitle: "Vecinos de un nodo",
      nodeIdLabel: "ID del nodo",
      neighborsRun: "Obtener vecinos",
      neighborsEmpty: "No se han encontrado vecinos.",
      nodeCol: "Nodo",
      edgeKindCol: "Arista",
      weightCol: "Peso",
      gapTitle: "Matriz de cobertura y brechas",
      gapSubtitle: "Inventario medido frente a los objetivos de mezcla configurados por capacidad, firma y nivel — una vista SQL sobre el catálogo, nunca cableada.",
      tier: "Nivel",
      gapHave: "Real",
      gapTarget: "Objetivo",
      gapWeight: "Peso",
      gapPriority: "Prioridad",
      targetsTitle: "Definir objetivos de mezcla",
      targetsSubtitle: "Los objetivos llevan autor y fecha; sin objetivos la matriz muestra honestamente el estado vacío.",
      addTargetRow: "Añadir fila",
      saveTargets: "Guardar objetivos",
      targetsSaved: "Objetivos guardados",
      statusCol: "Estado",
      tdvTitle: "Versión de datos sellada",
      tdvSubtitle: "La versión de datos es inmutable y se compone de shards sellados; una nueva sustituye a la anterior.",
      createTdv: "Crear borrador de TDV",
      tdvCreated: "Borrador de TDV creado",
      tdvId: "TDV",
      tdvName: "Nombre",
      tdvMembers: "Miembros",
      tdvCreatedAt: "Creada",
      tdvSealedAt: "Sellada",
      tdvStatusDraft: "borrador",
      tdvStatusSealed: "sellada",
      sealTdv: "Sellar",
      tdvSealed: "TDV sellada",
      tdvEmpty: "Aún no hay Train Data Version — se compone a partir de shards sellados.",
      compatTitle: "Comprobación de compatibilidad entre arquitectura y datos",
      compatSubtitle: "Reglas R1–R12 sobre dos documentos legibles por máquina; el panel muestra el informe almacenado del motor y no calcula ningún veredicto propio.",
      compatAllGreen: "ALL-GREEN",
      compatNotGreen: "no ALL-GREEN",
      compatRun: "Ejecutar comprobación",
      compatChecked: "Comprobación ejecutada",
      compatSelectTdv: "Seleccione una TDV en la lista superior para ver su informe.",
      compatNoReport: "Para esta TDV aún no existe un informe de compatibilidad almacenado.",
      compatDraftNote: "La interfaz de datos de la arquitectura es un borrador — los artefactos de tokenizer y códec aún no existen; la comprobación se activa con la primera publicación del tokenizer y la primera TDV sellada.",
      compatRule: "Regla",
      compatTitleCol: "Título",
      compatKind: "Tipo",
      compatEvidence: "Valores comparados (evidencia)",
      kindHard: "estricta",
      kindWarn: "aviso",
      reportsTitle: "Informes almacenados",
      reportsEmpty: "Aún no hay informes de compatibilidad almacenados.",
      phaseLabel: "Fase de entrenamiento",
      phaseA: "Fase A — preparación y evolución",
      phaseB: "Fase B — entrenamiento en curso, arquitectura congelada",
      checklistTitle: "Preparación para el entrenamiento (lista de verificación de la fase A)",
      checklistSubtitle: "Condiciones calculadas en directo; el arranque permanece bloqueado hasta que cada punto esté en verde, y cada punto incumplido se nombra.",
      checklistReady: "listo",
      checklistUnmet: "{count} puntos incumplidos",
      checklistUnavailable: "La lista de verificación no está accesible.",
      itemSatisfied: "cumplido",
      itemUnsatisfied: "incumplido",
      startTraining: "Iniciar fase B",
      strandTitle: 'Rama de entrenamiento',
      strandSubtitle: 'Qué rama del modelo se entrena cuando se cumplen todas las condiciones; la rama no seleccionada sigue preparando datos pero nunca arranca.',
      strandSelectedBadge: 'seleccionada',
      strandExplain: 'El autopiloto entrena {selected}. {other} sigue recopilando y preparando, pero no arranca mientras no esté seleccionada.',
      strandSwitched: 'Selección guardada.',
      strandSwitchFailed: 'No se pudo cambiar.',
      strandUnavailable: 'Este backend aún no ofrece ramas; el selector aparecerá tras el próximo despliegue del núcleo.',
      trainingStarted: "Fase B iniciada",
      startBlocked: "Arranque bloqueado — incumplidos: {items}",
      selectedTdvLabel: "Versión de datos elegida",
      computedAt: "Calculado",
      runsTitle: "Ejecuciones de entrenamiento",
      runsSubtitle: "Solo ejecuciones reales del catálogo; no existe ningún proceso de entrenamiento simulado.",
      runId: "Ejecución",
      archVersion: "Arquitectura",
      presetCol: "Preset",
      seqLenCol: "Longitud de secuencia",
      stepCol: "Paso",
      lossCol: "Loss",
      runStarted: "Iniciada",
      runFinished: "Finalizada",
      runsEmpty: "Aún no hay ejecuciones de entrenamiento.",
      abortRun: "Abortar",
      confirmAbort: "¿Abortar esta ejecución de entrenamiento?",
      runAborted: "Aborto solicitado",
      benchLink: "Benchmark",
      benchTitle: "Informes de benchmark",
      benchSubtitle: "La suite congelada y versionada se ejecuta automáticamente tras cada entrenamiento; cada informe se guarda en el lake y se muestra aquí.",
      benchEmpty: "Aún no hay informe de benchmark.",
      suiteVersion: "Suite",
      benchOpen: "Abrir",
      benchReportFor: "Informe de benchmark de la ejecución {run}",
      benchNoMarkdown: "Este informe no lleva documento renderizado; los resultados brutos están debajo.",
      exportsTitle: "Exportaciones",
      exportsSubtitle: "Las descargas existen exclusivamente para exportaciones de entrenamientos reales completados.",
      exportId: "Exportación",
      exportSize: "Tamaño",
      exportSha: "SHA-256",
      download: "Descargar",
      exportsEmpty: "Aún no hay exportaciones — solo nacen de un entrenamiento real completado.",
      hfTitle: "Publicaciones en HuggingFace",
      hfSubtitle: "Cada subida es privada; la visibilidad se verifica por API tras la subida. Un resultado no privado es un estado de error que detiene el ciclo.",
      hfEmpty: "Aún no hay publicación.",
      hfRepo: "Repositorio",
      hfState: "Estado",
      hfVisibility: "Visibilidad",
      hfPrivateVerified: "privado — verificado",
      hfUnverified: "aún no verificado",
      hfVerifiedAt: "Verificado",
      connectTitle: "Conectar Block Storage",
      connectSubtitle: "Inicio de sesión en la ventana de acceso del proveedor de almacenamiento; el almacenamiento se conecta con la cuenta que confirma.",
      webConnectStart: "Conectar con el proveedor de almacenamiento",
      webConnectWaiting: "Esperando la confirmación en la ventana de acceso del proveedor de almacenamiento…",
      webConnectHint: "Tras la confirmación, el almacenamiento se conecta automáticamente; este diálogo se actualiza solo.",
      publicIdentity: "Identidad de aplicación pública (rclone, cuota compartida)",
      publicIdentityNote: "La ventana de acceso del proveedor de almacenamiento muestra “rclone” como aplicación solicitante — la identidad compartida públicamente; un client ID propio (GDRIVE_OAUTH_CLIENT_ID) la sustituye en cualquier momento.",
      manualHint: "Tras confirmar, el navegador muestra una página localhost inaccesible. Copie el valor del parámetro code= de la barra de direcciones y péguelo aquí (pegar la dirección completa también funciona).",
      manualCodeLabel: "Código de autorización",
      manualSubmit: "Canjear código",
      deviceInstead: "Usar un código de dispositivo en su lugar",
      licenseAcceptLink: "Confirmar la licencia en Hugging Face",
      deviceFlowTitle: "Conectar Block Storage (device flow)",
      deviceFlowSubtitle: "El motor inicia el flujo de acceso del proveedor para dispositivos; la confirmación se hace en un segundo dispositivo y se consulta en intervalos acotados.",
      deviceFlowStart: "Iniciar flujo de acceso",
      deviceFlowCode: "Código de dispositivo",
      deviceFlowOpenUrl: "Abrir la página de confirmación",
      deviceFlowWaiting: "Esperando la confirmación — la consulta sigue el intervalo prescrito por el proveedor.",
      deviceFlowAuthorized: "Conectado",
      deviceFlowExpired: "El código de dispositivo ha caducado — reinicie el flujo de acceso.",
      readinessTitle: "Preparación para el entrenamiento",
      readinessSubtitle: "El camino medido hasta el primer entrenamiento, etapa por etapa.",
      readinessCounter: "{green} de {total} cumplidas",
      readinessReady: "Listo para entrenar",
      unblockLabel: "Siguiente paso",
      readinessUnavailable: "El resumen de preparación aún no está desplegado en el backend. En cuanto el endpoint esté activo, aquí aparecerá el estado medido.",
      stageStates: {
        ok: "cumplida",
        active: "en curso",
        waiting: "en espera",
        blocked: "bloqueada",
      },
    },
    gt: {
      loading: '…',
      unavailable: 'no disponible',
      equilibrium: 'Estado operativo óptimo alcanzado: todas las consultas fueron respondidas, todos los traspasos de tareas procesados y se evitaron redundancias.',
      standby: 'en espera',
      defTitle: 'Coordinación Operativa del Equipo y Métricas de Rendimiento',
      defSubtitle: 'Medición de la calidad operativa de comunicación y traspaso de todos los roles de IA: enfoque en resultados verificados en lugar de actividad improductiva.',
      defPlayers: 'Roles y Sistemas Participantes',
      defPlayersText: 'Los diez roles especializados de IA con sus bots de Webex junto con los responsables humanos que definen encargos y directrices.',
      defStrategies: 'Principios de Comunicación y Trabajo',
      defStrategiesText: 'Respuesta directa a consultas, traspasos de tareas completos e inequívocos, prevención de redundancias y cierre riguroso de paquetes de trabajo abiertos.',
      defPayoff: 'Contribución Operativa Neta (Utilidad Neta)',
      defPayoffText: 'Paquetes de trabajo completados, traspasos procesados con éxito y consultas respondidas — menos pérdidas por fricción (redundancias, traspasos sin procesar, consultas sin respuesta).',
      defEquilibrium: 'Estado Operativo Óptimo (Equilibrio de Coordinación)',
      defEquilibriumText: 'Estado objetivo de colaboración: cada consulta se responde a tiempo, cada traspaso de tarea se asume, ninguna información se envía dos veces y ningún paquete de trabajo queda estancado.',
      playersTitle: 'Resumen de Rendimiento por Rol (Posiciones)',
      playersSubtitle: 'Indicadores operativos de comunicación y entrega por rol: aportaciones técnicas y traspasos (últimos 7 días), así como reuniones y paquetes completados (últimos 30 días).',
      playersHint: 'Utilidad neta = 3 × paquetes completados + traspasos procesados − pérdidas por fricción (los traspasos no procesados cuentan doble). Un valor negativo indica necesidad de coordinación.',
      player: 'Rol / Posición',
      contributions: 'Aportaciones',
      meetingTurns: 'Reuniones',
      handovers: 'Traspasos',
      consumedShort: 'procesados',
      refusedShort: 'rechazados',
      delivery: 'Entrega',
      pausedTurns: 'Turnos en pausa',
      pausedTurnsHint: 'Turnos guardados en el buzón del propio colega porque los modelos no pudieron atenderlos en ese momento. No son traspasos.',
      closedOpen: 'cerrados / abiertos',
      noise: 'Pérdida por fricción',
      utility: 'Contribución neta',
      meetingsLine: '{held} reuniones, {turns} intervenciones, {u} interpelaciones sin respuesta (30 días).',
      interactionsTitle: 'Traspasos de Tareas entre Roles (Matriz de Handover)',
      interactionsSubtitle: 'Traspasos dirigidos entre buzones (últimos 7 días): volumen, tiempo de entrega y traspasos procesados o rechazados.',
      interactionsHint: 'Un traspaso de tarea solo se considera completado tras ser procesado por el destinatario; los traspasos rechazados o no procesados se registran como desviaciones de proceso.',
      interactionsEmpty: 'No hay traspasos en la ventana.',
      from: 'De',
      to: 'A',
      messages: 'Mensajes',
      consumed: 'procesados',
      refused: 'rechazados',
      deviationsTitle: 'Desviaciones de Proceso y Cuellos de Botella Abiertos',
      deviationsSubtitle: 'Deficiencias de coordinación actuales: consultas sin respuesta, traspasos sin procesar, aportaciones redundantes o paquetes de trabajo bloqueados.',
      dev_unanswered_question: 'Consulta sin respuesta (tiempo agotado)',
      dev_dead_air: 'Traspaso de tarea sin respuesta',
      dev_repetition: 'Repetición en la reunión',
      dev_meeting_unanswered: 'Solicitud directa sin respuesta',
      dev_work_blocked: 'Trabajo bloqueado',
      dev_handover_hop_budget_reached: 'Presupuesto de saltos de traspaso superado',
      dev_commitment_unkept: 'Compromiso de sprint incumplido',
      devWithheld: 'retenido',
      devRepetition: 'repetición',
      devDeadAir: 'traspaso no procesado',
      devMeetingUnanswered: 'sin respuesta',
      effectiveThresholdCol: 'Umbral ef.',
      excessHopsLabel: 'Saltos de traspaso en exceso',
      timeTitle: 'Tiempos de Ciclo y Comparativa de Productividad (IA vs. ejecución manual)',
      timeSubtitle: 'Duración medida de procesamiento por IA en tareas de desarrollo completadas en comparación con el esfuerzo manual estimado.',
      timeHint: 'Valores de referencia analíticos para la estimación de esfuerzo; configurables por la dirección.',
      avgCycle: 'Ciclo IA medio',
      fromTasks: 'de {n} tareas',
      speedup: 'Aceleración',
      speedupHint: 'se asumen {h} horas humanas por pieza',
      humanDelivered: 'Días-persona entregados',
      humanDays: 'días-persona',
      forecast: 'Pronóstico del trabajo abierto: {d} días-persona',
      sizes: 'Tamaños',
      sizeSmall: 'pequeñas',
      sizeMedium: 'medianas',
      sizeLarge: 'grandes',
      scrumTitle: 'Scrum',
      scrumSubtitle: 'El sprint, sus story points y la velocidad, de los datos propios de la empresa',
      sprintLabel: 'Sprint {n}',
      ends: 'termina',
      committedPts: 'Puntos comprometidos',
      deliveredPts: 'Puntos entregados',
      remainingPts: 'Puntos restantes',
      burndownTitle: 'Burndown (puntos restantes por día)',
      velocityTitle: 'Velocidad de los sprints cerrados',
      predictability: 'previsibilidad',
      forecastLine: 'Velocidad móvil {v} puntos por sprint · backlog {b} puntos ≈ {s} sprints',
      noSprint: 'No hay sprint en curso; la próxima planificación abre uno.',
      noItems: 'Aún no hay nada comprometido; el sprint toma lo que traen las personas.',
      colItem: 'Elemento',
      colOwner: 'Responsable',
      colPoints: 'Puntos',
      colState: 'Estado',
      itemDone: 'entregado',
      itemOpen: 'abierto',
      unestimated: 'sin estimar',
      addedBy: 'añadido por {who}',
      setGoal: 'Objetivo del sprint',
      sprintDaysLabel: 'Duración del sprint (días)',
      save: 'Guardar',
      endSprint: 'Terminar el sprint ahora',
      confirmEndSprint: '¿Terminar el sprint ahora? La revisión, la retrospectiva y la próxima planificación se celebran de inmediato.',
      planNow: 'Celebrar la primera planificación ahora',
      confirmPlanNow: '¿Celebrar la planificación del sprint ahora? Abre el primer sprint en pAIoneer-scrum.',
      sprintPointsCol: 'Puntos del sprint',
      ceremonySpaceLabel: 'Espacio de ceremonia',
      scrumOfScrums: 'Celebrar Scrum of Scrums',
      confirmScrumOfScrums: '¿Celebrar Scrum of Scrums entre todas las unidades de negocio ahora?',
      lastScrumOfScrumsTitle: 'Último Scrum of Scrums',
      escalatedImpedimentsTitle: 'Impedimentos escalados',
      unitBreakdownTitle: 'Desglose del sprint por unidad de negocio',
      colUnit: 'Unidad de negocio',
      colWip: 'Trabajo abierto',
      colImpediments: 'Impedimentos',
    },
    nav: {
      groups: {
        gametheory: 'Coordinación de Equipo y Scrum',
        demos: 'Vistas Previas en Vivo',
        sovereign: 'LLM soberano',
        today: 'Resumen Ejecutivo y Centro de Control',
        organisation: 'Organización',
        work: 'Trabajo',
        communication: 'Comunicación',
        memory: 'Memoria',
        platform: 'Plataforma',
        products: 'Productos',
        identity: 'Identidad',
      },
      pages: {
        gametheory: 'Coordinación de Equipo y Scrum',
        demos: 'Vistas Previas en Vivo',
        llm: 'Arquitectura LLM — artículo',
        training: 'Data Lake y Entrenamiento de Modelos IA',
        today: 'Resumen Ejecutivo y Centro de Control',
        work: 'Paquetes de trabajo y proyectos',
        coding: 'Tareas de programación',
        gitlab: 'GitLab y Builds de imágenes',
        agents: 'Agentes y diseños',
        research: 'Investigaciones',
        webex: 'Espacios de Webex',
        mailboxes: 'Buzones',
        conversations: 'Llamadas y conversaciones',
        meetings: 'Reuniones',
        engines: 'Motores IA y GPU',
        usage: 'Consumo y presupuestos',
        workloads: 'Servicios de contenedores',
        orchestrator: 'Orquestador MCP de Veridion',
      },
      sections: {
        demos: {
          previews: 'Vistas previas en vivo',
        },
        llm: {
          paper: 'Artículo',
          monitoring: 'Supervisión',
        },
        training: {
          autopilot: "Autopiloto",
          storage: "Almacenamiento en la nube y árbol de carpetas",
          acquisition: "Adquisición y preprocesamiento",
          data: "Datos y grafo de conocimiento",
          training: "Entrenamiento y publicación",
        },
        platform: {
          nodes: 'Nodos del clúster',
          events: 'Eventos',
        },
        smtm: {
          runtime: 'Control de ejecución',
          prediction: 'Control de previsiones',
          status: 'Estado de los datos',
          reporting: 'Señales',
          training: 'Modelos',
          console: 'Consola de entrenamiento',
        },
        agentic: {
          overview: 'Resumen',
          tools: 'Herramientas',
          mcp: 'Servidores MCP',
          activity: 'Actividad',
        },
        'company-memory': {
          content: 'Contenido',
          search: 'Búsqueda e informes de situación',
          facts: 'Hechos',
          entity: 'Entidades',
          remember: 'Registrar',
          audit: 'Registro de auditoría',
          console: 'Consola de consultas',
          stores: 'Almacenes',
          graph: 'Grafo de conocimiento',
          day: 'Jornada',
            bubbles: 'Dominios de Conocimiento por Departamento e Investigación'
        },
        organisation: {
          chart: 'Organigrama',
          colleagues: 'Colegas de IA y buzones',
          voices: 'Voces',
          people: 'Personas y espacios',
          approvals: 'Aprobaciones y planificaciones',
          edit: 'Editar organización',
        },
        work: {
          items: 'Paquetes de trabajo',
          projects: 'Proyectos en desarrollo',
        },
        gitlab: {
          gitlab: 'GitLab',
          builds: 'Builds de imágenes',
        },
        agents: {
          agents: 'Agentes',
          designs: 'Diseños de agentes',
          definitions: 'Definiciones',
        },
        usage: {
          identities: 'Por identidad',
          budgets: 'Presupuestos de tokens',
          company: 'Instancia de la empresa',
          smtm: 'Veridion SMTM',
        },
        orchestrator: {
          runtime: 'Tiempo de ejecución',
          mcp: 'Servidores MCP',
          tools: 'Herramientas',
          activity: 'Actividad',
        },
      },
      attentionTitle: 'Requiere acción',
      attentionSubtitle: 'Estados de todas las áreas que requieren intervenir. Un clic abre la sección.',
      attentionNone: 'Nada requiere acción.',
      stateTitle: 'Estado operativo',
      none: 'ninguno',
      readyOf: '{ready} de {total} listos',
      connectedOf: '{connected} de {total} conectados',
      registeredOf: '{registered} de {total} registrados',
      showMore: 'Mostrar más',
      shownOf: '{shown} de {total}',
      expand: 'Desplegar',
      collapse: 'Plegar',
      service: 'Servicio',
      serviceLinks: 'Enlaces',
      controlsTitle: 'Controles de Veridion Core',
      confirmRemove: '¿Eliminar {what}?',
      companyIdentitiesTitle: 'Identidades de pasarela de la instancia de la empresa',
      companyIdentitiesSubtitle: 'Los tokens del orquestador y de Veridion Core en la ventana actual de la pasarela, cada identidad con su presupuesto.',
      conversationsTitle: 'Conversaciones desde el panel',
      conversationsSubtitle: 'Por colega de IA, las conversaciones escritas desde el panel; escribir y llamar abren un diálogo sobre la página.',
      conversationCount: 'Mensajes',
      conversationLastWritten: 'Último mensaje',
      conversationLastAnswered: 'Última respuesta',
      exchangesTitle: 'Mensajes y respuestas',
      exchangesSubtitle: 'Cada mensaje del panel con la respuesta del colega de IA, el más reciente primero.',
      conversationMessage: 'Mensaje',
      conversationAnswer: 'Respuesta',
      today: {
        wordTitle: 'Directiva ejecutiva vigente',
        wordNone: 'Actualmente no hay ninguna directiva ejecutiva abierta registrada.',
        sinceTitle: 'Eventos desde la última consulta',
        sinceState: 'desde {time}',
        workTitle: 'Tareas activas y Responsabilidades',
        workNone: 'Ningún paquete de trabajo está en curso.',
        nextMeeting: 'Próxima reunión',
        lastMeeting: 'Última reunión',
      },
      work: {
        title: 'Paquetes de trabajo',
        subtitle: 'Cada paquete de trabajo abierto de la memoria de la empresa con su responsable, estado, prioridad, plazo y los resultados de sus escenarios; el título lo abre en el grafo.',
        item: 'Paquete de trabajo',
        kind: 'Tipo',
        owner: 'Responsable',
        status: 'Estado',
        priority: 'Prioridad',
        due: 'Plazo',
        scenarios: 'Escenarios',
        updated: 'Actualizado',
        none: 'Ningún paquete de trabajo abierto.',
        all: 'Todos los responsables',
      },
      meetings: {
        subtitle: 'Las reuniones de los colegas de IA tal como las registra Veridion Core: franja, resumen y los compromisos que se convirtieron en trabajo.',
        slot: 'Franja',
        kind: 'Tipo',
        started: 'Inicio',
        ended: 'Fin',
        summary: 'Resumen',
        commitments: 'Compromisos',
        hold: 'Celebrar una reunión ahora',
        held: 'La reunión ha sido convocada.',
        notHeld: 'Hay una reunión en curso o se celebró en la última media hora.',
        holdFailed: 'No se pudo convocar la reunión',
        none: 'Aún no hay ninguna reunión registrada.',
      },
      research: {
        title: 'Investigaciones',
        subtitle: 'Las investigaciones de los colegas de IA de la cronología de la empresa, las más recientes primero.',
      },
      attention: {
        toneError: 'Fallo',
        toneWarning: 'Aviso',
        state: {
          platform: '{ready} de {workloads} workloads listos, {nodes} de {total} nodos listos, {restarts} reinicios.',
          gateway: '{state}; {models} modelos enrutados, {backends} de {total} backends de servicio listos.',
          engine: '{engine}: {running} en curso, {waiting} en espera',
          usage: '{tokens} tokens en {identities} identidades en la ventana {window}.',
          smtm: 'Compuerta de predicción {gate}, reconstrucción {rebuild}; {online} de {models} modelos en línea, {failed} fallidos.',
          smtmSignals: '{open} señales abiertas, {resolved} resueltas, {failed} entregas fallidas.',
          smtmVeridion: '{connected} de {servers} servidores MCP conectados.',
          company: 'Orquestador {status}; {ready} de {workloads} workloads listos; Veridion Core {core}; {agents} agentes en ejecución, {waiting} en espera.',
          companyWebex: '{registered} de {bots} webhooks de bots registrados.',
          approvals: '{approvals} aprobaciones abiertas; {tasks} tareas de codificación esperan a una persona o una revisión.',
          sessions: '{users} usuarios conectados, {sessions} sesiones, {mfa} verificadas, {total} cuentas.',
          mail: 'SMTP {state}.',
        },
        platformUnreadable: 'El estado de la plataforma no se puede leer.',
        nodeNotReady: 'El nodo {name} no está listo.',
        nodePressure: 'El nodo {name} informa de saturación: {pressure}.',
        workloadDown: '{name} ({namespace}): {ready} de {desired} listos.',
        gatewayNotProgrammed: 'La pasarela de IA no está programada.',
        smtmGateClosed: 'La compuerta de previsiones está cerrada.',
        smtmRebuild: 'Hay una reconstrucción marcada.',
        smtmHint: 'Estado de los datos: {hint}.',
        smtmDeliveryFailed: '{count} entregas de señales han fallado.',
        smtmModelsFailed: '{count} modelos informan de un error.',
        mcpUnreachable: 'El servidor MCP {server} de {instance} no está disponible.',
        partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} no responde.',
        parts: {
          orchestrator: 'el orquestador',
          webex: 'el puente de Webex',
          knowledge: 'la base de conocimiento',
          core: 'Veridion Core',
          mcp: 'los servidores MCP',
          usage: 'el registro de consumo',
          gateway: 'el consumo de la pasarela',
        },
        emergencyStop: 'La parada de emergencia de Veridion Core está activa.',
        coreMisconfigured: 'A Veridion Core le faltan ajustes: {missing}.',
        agentsWaiting: '{count} agentes esperan una respuesta.',
        hostedNotRunning: '{agent} no está en ejecución.',
        webhookMissing: 'El webhook de {bot} no está registrado.',
        readerNotAuthorised: 'La lectura de los espacios de la empresa no está autorizada.',
        approvalOpen: 'Aprobación abierta ({position}): {question}',
        taskWaiting: 'Tarea de código a la espera de una persona: {title}',
        taskReview: 'Merge request lista para revisión: {title}',
      },
    },
    ops: {
      showDetails: 'Detalles',
      hideDetails: 'Cerrar',
      mcpVersion: 'Versión',
      mcpUrl: 'Dirección',
      mcpProtocol: 'Transporte y protocolo',
      mcpLastRefresh: 'Última consulta',
      mcpError: 'Error',
      noTools: 'No se informan herramientas.',
      toolServer: 'Origen',
      toolAccess: 'Acceso',
      toolBuiltIn: 'Veridion',
      accessReadOnly: 'lectura',
      accessWrites: 'escritura',
      accessDestructive: 'modifica datos',
      accessUndeclared: 'no declarado',
      usageTitle: 'Consumo',
      smtmUsageSubtitle: 'Llamadas a modelos, tokens y costes declarados por el proveedor en los últimos 30 días.',
      usageByPerson: 'Por persona',
      usageByModel: 'Por modelo',
      usageByDay: 'Por día',
      model: 'Modelo',
      day: 'Día',
      promptTokens: 'Tokens de entrada',
      completionTokens: 'Tokens de salida',
      noUsage: 'No hay consumo registrado.',
      runtimeTitle: 'Ejecución',
      runtimeSubtitle: 'Cómo el orquestador de esta instancia se dirige a sus modelos y conecta sus herramientas.',
      executionMode: 'Ejecución',
      providerProtocol: 'Protocolo hacia el modelo',
      contextWindow: 'Ventana de contexto',
      requestTimeout: 'Tiempo límite por petición',
      diagnostics: 'Diagnóstico',
      diagnosticsOn: 'activado',
      diagnosticsOff: 'desactivado (modo rendimiento)',
      externalServers: 'Servidores MCP conectados',
      mcpEndpoint: 'Endpoint MCP',
      workloadsTitle: 'Workloads',
      workloadsSubtitle: 'Los workloads del namespace paioneer-veridion tal como los informa Kubernetes.',
      botsTitle: 'Bots',
      botsSubtitle: 'Los bots de la organización, cada uno con su webhook, y los servicios del puente.',
      botAddress: 'Dirección',
      cardWebhook: 'Webhook de tarjetas',
      webhookState: 'Estado',
      noBots: 'El puente no informa de bots.',
      bridgeServices: {
        knowledgeBase: 'Base de conocimiento',
        webResearch: 'Búsqueda en Internet',
        osint: 'OSINT',
        anonymizer: 'Anonimización',
      },
      connected: 'conectado',
      notConnected: 'no conectado',
      activeRooms: 'Salas activas',
      allowedRooms: 'Salas permitidas',
      surface: 'Superficie',
      missingSettings: 'Ajustes que faltan',
      none: 'ninguno',
      instanceToolsTitle: 'Herramientas del orquestador',
      instanceToolsSubtitle: 'Las herramientas que ha registrado el orquestador de la instancia de la empresa.',
      openMailbox: 'Buzón',
      positionMailboxHint: 'Los colegas de IA procesan traspasos de otros colegas de IA; un encargo a un colega de IA se da en su espacio de Webex.',
      mailboxesTitle: 'Buzones',
      mailboxesSubtitle: 'Para cada agente, lo que espera en su buzón, se ha entregado y se ha leído. Un clic en una fila filtra los mensajes.',
      readAt: 'Leído a las',
      refresh: 'Actualizar',
      mailbox: 'Buzón',
      mailboxKind: 'Tipo',
      mailboxKinds: {
        position: 'Colega de IA',
        hosted: 'Agente alojado',
        graph: 'Agente',
      },
      lastMessage: 'Último mensaje',
      noMailboxes: 'No se puede leer ningún buzón.',
      messagesTitle: 'Mensajes',
      messagesSubtitle: 'Mensajes, comandos y traspasos, los más recientes primero. Un clic muestra el texto completo.',
      allMailboxes: 'Todos los buzones',
      allStates: 'Todos los estados',
      time: 'Hora',
      from: 'De',
      to: 'Para',
      messageKind: 'Tipo',
      content: 'Contenido',
      reply: 'Respuesta',
      noMessages: 'No hay mensajes.',
      messageKinds: {
        message: 'Mensaje',
        handover: 'Traspaso',
        command: 'Comando',
        resume: 'Reanudación',
        subagent_result: 'Resultado de un subagente',
        review: 'Revisión',
      },
      buildsTitle: 'Builds',
      buildsSubtitle: 'Las imágenes que Veridion Core ha construido para agentes, las más recientes primero.',
      image: 'Imagen',
      started: 'Iniciado',
      finished: 'Terminado',
      noBuilds: 'No hay builds.',
      coreToolsTitle: 'Herramientas de los agentes',
      coreToolsSubtitle: 'Las herramientas del orquestador que Veridion Core ofrece a sus agentes.',
      description: 'Descripción',
      coreDailyTitle: 'Consumo por día y modelo',
      coreDailySubtitle: 'Llamadas a modelos de Veridion Core en los últimos 30 días, por agente y modelo.',
      coreActivityTitle: 'Actividad de Veridion Core',
      coreActivitySubtitle: 'Eventos de agentes, colegas de IA y traspasos en Veridion Core, los más recientes primero.',
      event: 'Evento',
      tool: 'Herramienta',
      detail: 'Detalle',
    },
    tabCompanyMemory: 'Memoria de la empresa',
    llmPaper: {
      subtitle: 'La descripción científica generada de la arquitectura soberana del modelo — renderizada a partir del documento tipo artículo que Veridion Core mantiene para la especificación activa.',
      summaryTitle: 'Qué muestra esta página',
      summaryBody: 'Veridion Core mantiene para la arquitectura activa un documento científico generado: título, resumen, secciones numeradas, diagrama de la arquitectura, tablas y referencias llegan del backend sin cambios; los valores de diseño están marcados como tales y la página no inventa nada.',
      refresh: 'Actualizar',
      exportPdf: 'Exportar como PDF',
      strandTraining: 'en entrenamiento',
      strandSelected: 'seleccionada',
      lcTitle: "Implementación y ciclo de vida",
      lcSelectedTrains: "entrena a continuación",
      lcCollectsOnly: "recopila y prepara — no inicia",
      lcSpec: "Especificación",
      lcFrozen: "congelada",
      lcArtifacts: "Artefactos (tokenizador/códec)",
      lcReleased: "publicados",
      lcNotReleased: "aún sin construir",
      lcCodecOpen: "códec pendiente",
      lcData: "Umbrales de datos",
      lcThresholdsMet: "cumplidos",
      lcAreasReached: "plan de datos: {met} de {total} áreas alcanzadas",
      lcNoLake: "lago de datos no disponible",
      lcStage_trainer_image: "Imagen del entrenador",
      lcStage_sealed_tdv: "TDV sellada",
      lcStage_compat_all_green: "Compatibilidad ALL-GREEN",
      lcStage_vram_budget: "Presupuesto VRAM",
      lcTraining: "Entrenamiento",
      lcAuto: "inicia automáticamente al cumplirse los umbrales",
      lcBench: "Benchmark",
      lcBenchRows: "mediciones",
      lcNoneYet: "aún ninguna",
      lcRelease: "Exportación · Hugging Face (privado) · registro",
      lcReleaseRows: "artefactos",
      lcReleaseNote: "tras el entrenamiento: subida verificada privada + entrada en el registro",
      lcPipeline: "Pipeline de entrenamiento",
      lcDone: "hecho",
      lcActive: "activo",
      lcWaiting: "en espera",
      lcBlocked: "bloqueado",
      lcCapability: "Capacidad",
      lcSamples: "Muestras",
      lcByLanguage: "por idioma",
      lcForeign: 'otra línea',
      lcCorpus: 'Tokens del corpus',
      lcCorpusNone: 'aún no tokenizado',
      loading: 'Cargando …',
      unavailable: 'El documento no está accesible.',
      noPaper: 'Esta versión de Veridion Core aún no sirve un documento tipo artículo. Por eso la página no muestra nada inventado.',
      abstract: 'Resumen',
      references: 'Referencias',
      appendix: 'Apéndice',
      figure: 'Figura',
      lastUpdated: 'Última actualización',
      empty: 'Sin entradas.',
    },
    llmMonitor: {
      summary: "Supervisión operativa del modelo: estado, datos, GPU, kernels y rendimiento, evaluaciones y eventos — medido desde Veridion Core y el data lake, nada inventado.",
      archTitle: 'Estado de la arquitectura',
      archSubtitle: "La arquitectura activa con el estado de la interfaz de datos y el estado de congelación.",
      version: 'Versión',
      codename: 'Nombre en clave',
      statusLabel: 'Estado',
      interfaceStatus: 'Interfaz de datos',
      specSha: 'Hash de la especificación (SHA-256, abreviado)',
      promotedAt: 'Promovida',
      frozenLabel: 'Congelada',
      frozenYes: 'Sí',
      frozenNo: 'No',
      stateWord_active: "activa",
      stateWord_draft: "borrador",
      stateWord_released: "publicada",
      stateWord_candidate: "candidata",
      stateWord_retired: "retirada",
      gpuModel: "Tarjeta gráfica",
      gpuTotal: "Memoria gráfica total",
      gpuWindow: "Ventana de entrenamiento (medida)",
      gpuMeasuredAt: "Medido el",
      gpuSource: "Fuente de la medición",
      gpuServing: "Servicio",
      gpuInferenceTarget: "Objetivo de inferencia en una tarjeta",
      vramTitle: 'GPU y presupuesto de VRAM',
      vramSubtitle: 'El presupuesto de VRAM medido de la tarjeta gráfica tal como lo mantiene Veridion Core.',
      vramNone: 'No hay presupuesto de VRAM en el registro.',
      gateTitle: 'Gate de promoción',
      gateSubtitle: 'La política con la que una arquitectura candidata sustituye a la activa, con las métricas requeridas y sus pesos.',
      metric: 'Métrica',
      weight: 'Peso',
      gateNone: 'No hay métricas requeridas registradas.',
      candidatesTitle: 'Candidatas',
      candidatesNone: 'No hay arquitecturas candidatas.',
      evidenceTitle: 'Evaluaciones',
      evidenceNone: 'Aún no hay evaluaciones medidas.',
      benchmark: 'Benchmark',
      suite: 'Suite',
      score: 'Puntuación',
      evaluator: 'Evaluador',
      date: 'Fecha',
      changelogTitle: 'Historial de cambios',
      changelogNone: 'Aún no hay versiones de la arquitectura en el historial.',
      summaryLabel: 'Resumen',
      createdAt: 'Creada',
      supersededAt: 'Sustituida',
      eventsTitle: 'Eventos',
      eventsNone: 'No hay eventos registrados.',
      implTitle: 'Estado de implementación de la rama',
      implSubtitle: "Hechos medidos: artefactos de la interfaz de datos, selección, corpus de tokens e índice vectorial; el plan de datos por área está en la situación.",
      implSelected: 'Rama de entrenamiento',
      implSelectedYes: 'seleccionada — se entrena a continuación',
      implSelectedNo: 'solo prepara (nunca arranca)',
      implTokenizer: 'Artefacto del tokenizador',
      implCodec: 'Artefacto del códec',
      implNotReleased: 'aún no publicado',
      implCapability: 'Capacidad',
      implSamples: 'Ejemplos (medido/objetivo)',
      implNoDatalake: 'El progreso de ejemplos no es legible en este momento (interfaz del data lake inaccesible).',
      implSwitchHint: 'La selección de la rama de entrenamiento se cambia en la página de entrenamiento.',
      implSituationLink: "Dónde están los datos y qué falta para el entrenamiento: la situación en la página de entrenamiento",
      kernelTitle: 'Aceleración de kernels y rendimiento',
      kernelSubtitle: 'Lo que la sonda de kernels midió en la tarjeta: cada kernel frente a su referencia, el backend de atención, el rendimiento de la especificación elegida — y el plan de tiempo calculado con tokens medidos y rendimiento medido.',
      kernelNone: 'Aún no se ha ejecutado ninguna sonda de kernels en esta tarjeta; no se supone nada.',
      kernelName: 'Kernel',
      kernelVerified: 'Probado',
      kernelYes: 'sí',
      kernelNo: 'no',
      kernelSpeedup: 'Aceleración',
      kernelMaxErr: 'Error máx.',
      kernelError: 'Hallazgo',
      kernelAttention: 'Backend de atención',
      kernelDocMask: 'Enmascaramiento de límites de documento',
      kernelThroughput: 'Rendimiento medido (tokens/s)',
      kernelMicroBatch: 'Microlote',
      kernelMeasuredAt: 'Medido el',
      kernelImage: 'Imagen del trainer (digest)',
      kernelRunPath: 'Ruta de kernels de la última ejecución',
      kernelRunNone: 'Todavía no hay ninguna ejecución de entrenamiento con datos de kernels.',
      kernelPlanTitle: 'Plan de tiempo (aritmética sobre mediciones)',
      kernelPlanTokens: 'Masa de tokens',
      kernelPlanTokensSource: 'Origen de la masa de tokens',
      kernelPlanDays: 'Días proyectados para una pasada',
      kernelPlanNone: 'Aún no medido — sin rendimiento medido ni masa de tokens medida no se inventa ningún plan de tiempo.',
      kernelSourceTdv: 'versión de datos de entrenamiento sellada',
      kernelSourceCorpus: 'corpus hasta ahora (sin sellar)',
      kernelSourcePlan: "presupuesto del paper",
      implForeign: 'pertenece a otra línea',
      implIndex: 'Índice vectorial (enlace del grafo)',
      implIndexNone: 'ningún índice notificado',
      implIndexDown: 'configurado, no responde',
      implIndexPoints: 'puntos',
      implIndexBackfillDone: 'relleno completado',
      implIndexBackfillOpen: 'relleno en curso',
      implIndexLink: 'Índice y deduplicación en el monitor del lago',
      implCorpus: 'Corpus de tokens (texto bruto)',
    },
    software: {
      arch: {
        execTitle: "Arquitectura de modelo soberana",
        execSubtitle: "La única especificación de arquitectura activa de Veridion Core: cada cifra está respaldada por un artefacto de medición referenciado o marcada por el backend como objetivo de diseño (sin medir).",
        openDatalake: "Abrir Data Lake y entrenamiento del modelo de IA",
        unavailableArch: "Los datos de la arquitectura no están accesibles.",
        frozen: "Congelada — hay un entrenamiento activo",
        notFrozen: "Autorizada (fase A)",
        version: "Versión",
        codename: "Nombre en clave",
        statusLabel: "Estado",
        createdAt: "Creada",
        promotedAt: "Promovida",
        specSha: "Hash de la especificación (SHA-256)",
        contextWindow: "Ventana de contexto (diseño, tokens)",
        dataInterface: "Interfaz de datos",
        diStatus: {
          draft: "borrador",
          complete: "completa",
          missing: "ausente",
        },
        paramsTitle: "Balance de parámetros",
        trainingVramTitle: "VRAM de entrenamiento (declarada, GB)",
        inferenceTitle: "VRAM de inferencia (declarada, GB)",
        declaredTotal: "Total declarado",
        budgetTitle: "Presupuesto de VRAM de la GPU (medido)",
        budgetGpu: "GPU",
        budgetTotal: "VRAM total (MiB)",
        budgetFreed: "Presupuesto de entrenamiento libre (GB)",
        budgetInferenceTarget: "Objetivo de inferencia en una sola GPU (GB)",
        diagramTitle: "Diagrama de arquitectura generado",
        diagramSubtitle: "Generado de forma determinista a partir de la especificación almacenada; junto a los datos no existe ningún diagrama escrito a mano.",
        noDiagram: "La respuesta no contiene diagrama.",
        stagesTitle: "Estructura por etapas de la arquitectura",
        stagesSubtitle: "Directamente de la especificación almacenada; las cifras de parámetros son valores de diseño.",
        stageCol: "Etapa",
        layersCol: "Capas",
        mechanismCol: "Mecanismo",
        paramsCol: "Parámetros físicos (mil millones) y fuentes primarias",
        paramsCross: "transversal — contado dentro de las etapas",
        researchTitle: "Archivo de investigación de IA cuántica y de frontera",
        researchSubtitle: "Filas en directo del archivo de investigación de Veridion Core; las publicaciones nuevas llegan por la herramienta del colega cuántico, cada una con su origen visible.",
        researchEmpty: "Aún no hay publicaciones en el archivo.",
        evidenceTitle: "Evidencias de evaluación",
        evidenceSubtitle: "Aquí solo aparecen evaluaciones medidas y referenciadas; sin evidencia no hay puntuación.",
        evalMetric: "Métrica",
        evalBenchmark: "Benchmark",
        evalSuite: "Suite",
        evalScore: "Valor",
        evalEvaluator: "Evaluador",
        evalDate: "Medida el",
        evalArtifact: "Artefacto de evidencia",
        gateTitle: "Reglas de promoción (puerta de evidencias)",
        gateMetrics: "Métricas obligatorias",
        gateEpsilon: "Tolerancia (épsilon)",
        gateConfigVersion: "Configuración de la puerta (versión)",
        candidatesTitle: "Cola de candidatos",
        candidatesSubtitle: "Candidatos de arquitectura presentados con el estado de sus evidencias; la presentación se hace desde el runtime de investigación, nunca desde el panel.",
        candidateSubmittedBy: "Presentado por",
        candidateEvidence: "Evidencias (presentes / requeridas)",
        candidatesEmpty: "Ningún candidato presentado.",
        changelogTitle: "Registro de cambios de diseño",
        changelogSubtitle: "Iteraciones de diseño sustituidas — deliberadamente sin cifras: nunca se midió nada para ellas.",
        changelogSummary: "Resumen",
        changelogEmpty: "Ningún diseño sustituido.",
        supersededAt: "Sustituida el",
        eventsTitle: "Eventos de la puerta",
        eventsSubtitle: "Presentaciones, promociones, rechazos y transiciones de congelación tal como la puerta las registró.",
        eventsEmpty: "Aún no hay eventos.",
      },
      title: 'Desarrollo de software',
      subtitle: 'Las tareas del agente de programación, el GitLab de la empresa con su sincronización desde Azure DevOps, las merge requests que esperan revisión y los límites del nodo GitLab.',
      openGitlab: 'Abrir GitLab',
      openSonar: 'Abrir SonarQube',
      loading: 'Cargando …',
      failed: 'No ha funcionado',
      done: 'Hecho',
      unavailable: 'No disponible',
      capacityTitle: 'Nodo GitLab',
      capacitySubtitle: 'El guardián fija cada minuto los límites del nodo según la carga del servidor; la producción conserva su reserva.',
      stateLabel: 'Estado',
      memory: 'Memoria',
      cpu: 'CPU',
      disk: 'Disco',
      hostFree: 'Libre en el servidor',
      reserve: 'Reserva para producción',
      codingSlots: 'Tareas a la vez',
      pipelineQuota: 'Jobs del pipeline',
      recentActions: 'Últimas intervenciones del guardián',
      syncTitle: 'Sincronización desde Azure DevOps',
      syncSubtitle: 'El master de GitLab sigue al master de Azure; los commits que solo tenía GitLab se conservan bajo una etiqueta replaced/<hora>.',
      syncNow: 'Sincronizar ahora',
      syncStarted: 'Sincronización iniciada',
      azureCommit: 'Master de Azure',
      gitlabCommit: 'Master de GitLab',
      lastChange: 'Último cambio',
      lastRun: 'Última ejecución',
      replaced: 'Conservado bajo etiquetas',
      noneReplaced: 'nada',
      jobs: 'Últimas ejecuciones',
      error: 'Error',
      readyTitle: 'Merge requests listas para revisión',
      readySubtitle: 'Solo merge requests con pipeline en verde; se fusionan en GitLab.',
      noReady: 'Ninguna merge request espera revisión.',
      tasksTitle: 'Tareas de programación',
      tasksSubtitle: 'Cada trabajo de programación del agente con su estado, su merge request y sus tokens.',
      showFinished: 'Mostrar tareas terminadas',
      task: 'Tarea',
      requester: 'Solicitante',
      statusLabel: 'Estado',
      mergeRequest: 'Merge request',
      pipeline: 'Pipeline',
      tokens: 'Tokens',
      updated: 'Actualizado',
      noTasks: 'Todavía no hay tareas de programación.',
      phase: 'Paso',
      repository: 'Repositorio',
      branch: 'Rama',
      openQuestion: 'Pregunta abierta',
      result: 'Resultado',
      sendMessage: 'Escribir a la tarea',
      answerQuestion: 'Responder a la pregunta',
      urgent: 'Urgente: dirigir de inmediato el paso en curso',
      send: 'Enviar',
      messageSent: 'Entregado a la tarea',
      confirmCancel: '¿Cancelar esta tarea? Se cerrará una merge request abierta.',
      course: 'Curso de la sesión',
      messages: 'Mensajes',
      events: 'Eventos',
      none: 'ninguno',
      close: 'Cerrar',
      newTitle: 'Nueva tarea',
      newSubtitle: 'Dé desde aquí una tarea al agente de programación; sígala aquí y en su tarjeta de Webex.',
      brief: '¿Qué debe hacer el agente?',
      issue: 'Incidencia de YouTrack (opcional)',
      create: 'Crear tarea',
      created: 'Tarea creada',
      usersTitle: 'Administradores en GitLab',
      usersSubtitle: 'Cada administrador tiene un usuario de GitLab con derechos de administración; el housekeeping los mantiene al día con Keycloak.',
      email: 'Correo',
      gitlabUser: 'Usuario de GitLab',
      lastHousekeeping: 'Último housekeeping',
      sonarDeleted: 'Proyectos de SonarQube de ramas borradas eliminados',
      previewsTitle: 'Proyectos en desarrollo',
      previewsSubtitle: 'Cada proyecto en desarrollo se ejecuta exactamente una vez desde su primer merge: Veridion Core arranca el último estado verde de la rama principal (migration o master) en contenedores tras el inicio de sesión de administrador, lo renueva con cada pipeline verde, y aquí se arrancan, detienen y reinician los contenedores. Un proyecto cuya pipeline no construye nada ejecutable aparece aquí con el motivo.',
      previewsSummaryTitle: 'Qué muestra esta vista',
      previewsSummaryBody: 'Cada proyecto en desarrollo corre en su propio contenedor de vista previa detrás del inicio de sesión de administrador. La lista de arriba muestra el estado ejecutable más reciente de cada proyecto; la tabla de abajo, los contenedores en ejecución con estado, dirección y controles: abrir, iniciar, detener, reiniciar.',
      previewProject: 'Proyecto',
      previewState: 'Estado en ejecución',
      previewSince: 'Desde',
      previewAddress: 'Dirección',
      previewMergedAt: 'Fusionado',
      noPreviews: 'Ningún proyecto está en ejecución.',
      reasonsLabel: 'Causas de bloqueo y Diagnóstico',
      noProjects: 'Ningún proyecto en desarrollo.',
      qualityCoverage: 'Cobertura',
      qualityBugs: 'Bugs',
      qualitySmells: 'Code smells',
      qualityDuplication: 'Duplicación',
      qualityHotspots: 'Hotspots abiertos',
      qualityUnavailable: 'Sin mediciones de SonarQube',
      openPreview: 'Abrir',
      startPreview: 'Arrancar contenedores',
      stopPreview: 'Detener contenedores',
      previewStarted: 'Contenedores arrancados',
      previewStopped: 'Contenedores detenidos',
      restartPreview: 'Reiniciar contenedores',
      previewRestarted: 'Contenedores reiniciados',
      previewControl: 'Contenedores',
      resultTitle: 'Resultado en GitLab',
      resultJobs: 'Jobs y artefactos',
      resultSonar: 'SonarQube',
      resultDelivered: 'Entregado',
      previewStatus: {
        starting: 'iniciando',
        running: 'en ejecución',
        stopped: 'detenida',
        failed: 'fallida',
      },
      capacityStates: {
        ok: 'dentro de los límites',
        tight: 'justo: la producción necesita el espacio',
        full: 'lleno: sin trabajo nuevo',
        node_down: 'el nodo no está en marcha',
      },
      status: {
        queued: 'espera un hueco libre',
        working: 'en curso',
        waiting: 'espera una respuesta',
        review: 'en revisión',
        merged: 'fusionada en GitLab',
        done: 'terminada',
        needs_person: 'necesita a una persona',
        rejected: 'cerrada sin fusión',
        paused: 'en pausa',
        cancelled: 'cancelada',
        failed: 'fallida',
      },
      commands: {
        pause: 'Pausar',
        resume: 'Reanudar',
        cancel: 'Cancelar',
      },
      repositoryChoice: {
        auto: 'Decide el agente',
        company: '{project} (fusión por una persona)',
        own: 'Un proyecto propio en {group}',
      },
      userState: {
        ok: 'al día',
        created: 'creado',
        unblocked: 'desbloqueado',
        'made administrator': 'hecho administrador',
        blocked: 'bloqueado',
      },
    },
    org: {
      write: 'Escribir',
      call: "Llamar",
      callTitle: "Llamada con {bot}",
      writeTitle: 'Mensaje a {bot}',
      callConfirmEnd: '¿Terminar la llamada?',
      callSubtitle: 'El micrófono funciona durante toda la llamada. El bot saluda con su voz, responde brevemente, pregunta sobre los puntos abiertos y puede ser interrumpido. Cada frase queda también en Webex, en la sala directa con el bot.',
      callRinging: "Llamando …",
      callConnected: "Conectado",
      callEnded: "Finalizada",
      callEndedHangup: "Usted colgó",
      callEndedClosed: "La conexión se cerró",
      callEndedSilence: "90 segundos de silencio",
      callEndedLimit: "Se alcanzó el límite de 30 minutos",
      callEndedError: "Un error terminó la llamada",
      callHangUp: "Colgar",
      callLevel: "Nivel del micrófono",
      callYou: "Usted",
      callSpeaking: "El bot está hablando …",
      callThinking: 'La respuesta se está generando …',
      callOvertaken: "superada por su siguiente pregunta, no pronunciada",
      callNothingHeard: "No se escucharon palabras.",
      callMicDenied: "El navegador rechazó el micrófono; permítalo para esta página y llame de nuevo.",
      callNoVoice: "La voz no está disponible ahora; la respuesta queda como texto.",
      callRefused: "La llamada no fue aceptada: el billete no era válido o había caducado; llame de nuevo.",
      callFailed: "La llamada falló",
      voice: "Voz",
      voiceHint: "La voz con la que habla este colega: en Webex, cuando una persona pide escuchar la respuesta, y por teléfono. Por defecto es un locutor del modelo de audio en OpenRouter; una voz propia, clonada, del almacén de voces habla a través del motor de voz de la plataforma.",
      voiceSave: "Guardar voz",
      voiceDefault: "predeterminada",
      voiceNone: "sin voz",
      voiceCloud: "Locutores de OpenRouter (predeterminado)",
      voiceOwn: "Voces propias (clonadas)",
      voiceUploadTitle: "Subir una muestra de voz para este colega",
      voiceUploadHint: "Audio o vídeo, como máximo 25 MB; el Core convierte la muestra, conserva hasta 20 segundos, escucha sus palabras y guarda solo el clip de referencia. El colega habla de inmediato con esta voz.",
      voiceUploadName: "Nombre de la voz",
      voiceUploadConsent: "Confirmo que tengo derecho a usar esta voz para la empresa: es la mía o la persona ha dado su consentimiento.",
      voiceUploadButton: "Subir muestra",
      voiceUploadDone: "Voz guardada",
      voiceTooLarge: "El archivo supera los 25 MB.",
      voicesTitle: "Voces",
      voicesSubtitle: "Cada voz de la empresa es un clip de referencia en el almacén de voces de Veridion Core; el motor de voz la clona cada vez que un bot habla. Los nueve locutores anteriores están en él como clips capturados.",
      voiceSeconds: "Segundos",
      voiceSource: "Origen",
      voiceSourcePreset: "locutor capturado",
      voiceSourceUpload: "muestra subida",
      voiceAddedBy: "Añadida por",
      voiceConsentBy: "Consentimiento confirmado por",
      voiceWords: "Palabras del clip",
      voiceDelete: "Eliminar",
      voiceConfirmDelete: "¿Eliminar esta voz? Los colegas que la usan volverán a hablar con su voz predeterminada.",
      voiceCapture: "Capturar los locutores del motor de preajustes",
      voiceCaptureHint: "Pronuncia una frase fija por locutor a través del motor de preajustes y la guarda como clip; se ejecuta antes del cambio de motor.",
      voiceCaptured: "Capturadas",
      voiceEnginePresets: "El motor de voz ofrece locutores fijos; el almacén de voces no se usa.",
      chartTitle: "Organigrama",
      executiveTitle: 'Nivel directivo',
      unitsTitle: 'Unidades de negocio',
      unitLead: 'Responsable',
      unitSupporting: 'Con el apoyo de',
      unitMission: 'Misión',
      unitPrefix: 'Prefijo del hilo',
      standingActive: 'activo',
      standingStandby: 'en espera',
      standbyOn: 'Poner en espera',
      standbyOff: 'Activar',
      standbyHint: 'En espera, un colega no toma ningún turno por iniciativa de la empresa y no cuesta tokens; un mensaje directo de una persona sigue recibiendo respuesta.',
      confirmStandby: '¿Poner a {name} en espera?',
      confirmActivate: '¿Activar a {name}?',
      activity: 'Actividad',
      runtime: 'Entorno de ejecución',
      modelCloud: 'modelo en la nube',
      modelGpu: 'motor de la empresa',
      callModel: 'Modelo telefónico',
      calls30: 'Llamadas, últimos 30 días',
      telemetryLine: '{model} · {prompt}+{completion} tokens · {cost} · oído {asr} ms · mente {llm} ms · voz {tts} ms · total {total} ms{deferred}',
      telemetryDeferred: ' · {count} aplazados',
      chartSubtitle: "Los colegas de IA de Veridion: agentes en Veridion Core, cada uno accesible como su propio bot de Webex, por área; encima las personas que deciden, debajo los agentes sin bot propio y los espacios de la empresa, leídos en directo de Veridion Core y Webex.",
      chartPeople: "Personas que deciden",
      chartPeopleText: "Las personas que deciden lo deciden todo y actúan en {space}.",
      chartAgentsTitle: "Agentes sin bot propio: el agente de programación, el orquestador MCP de Veridion y los agentes que construye el arquitecto trabajan en nombre de un colega de IA y hablan a través de su bot",
      chartDesigned: "Agentes diseñados con el arquitecto",
      chartFor: "En nombre de",
      chartSystemsTitle: "Sistemas conectados",
      chartSpaceHome: "Espacio propio de",
      chartSpacePurpose: "Finalidad",
      chartRoomsTitle: "Espacios de la empresa en Webex",
      room: "Espacio",
      roomBots: "Bots",
      positionsTitle: "Colegas de IA",
      positionsSubtitle: "Cada colega de IA responde con su propio bot y lee sus espacios. Su descripción es la instrucción con la que trabaja.",
      bot: "Bot",
      position: "Función",
      statusLabel: "Estado",
      tokensUsed: "Tokens usados",
      tokens30: "Tokens, últimos 30 días",
      edit: "Editar",
      close: "Cerrar",
      description: "Descripción del colega de IA",
      save: "Guardar",
      resetDescription: "Restaurar la descripción predeterminada",
      interests: "Perfil de intereses",
      interestsHint: "Qué tipos de puntos y temas conciernen a este colega de IA y cuándo no le conciernen. El colega de IA mide cada mensaje de sus espacios con este perfil.",
      threshold: 'Umbral para intervenciones no solicitadas',
      thresholdHint: 'De 1 a 5: cuánto debe concernir un mensaje al colega de IA antes de que intervenga sin que se lo pidan. Con 1 interviene ya con poca relevancia, con 5 solo con relevancia alta.',
      saveProfile: "Guardar perfil",
      tools: "Herramientas",
      decisionMakersTitle: "Personas que deciden",
      decisionMakersSubtitle: "Cada una puede dar cualquier aprobación y responder cualquier pregunta de un colega de IA en Webex.",
      email: "Correo electrónico",
      add: "Añadir",
      remove: "Quitar",
      confirmRemove: "¿Quitar a esta persona?",
      readerTitle: "Lectura de los espacios de la empresa",
      readerSubtitle: "Un bot solo ve los mensajes en los que se le menciona. Veridion lee cada mensaje de los espacios de la empresa mediante la autorización de una cuenta que es miembro de todos.",
      notConfigured: "La integración no está configurada",
      authorised: "Autorizado",
      notAuthorised: "No autorizado",
      account: "Cuenta",
      validUntil: "Token de acceso válido hasta",
      renewUntil: "Autorización renovable hasta",
      authorise: "Autorizar la lectura",
      authoriseAgain: "Autorizar de nuevo",
      linkOpened: "El inicio de sesión de Webex se abrió en una pestaña nueva.",
      found: "encontrado",
      notFound: "no encontrado",
      botsInSpace: "bots",
      transcripts: "Transcripciones de reuniones",
      yes: "sí",
      no: "no",
      approvalsTitle: "Aprobaciones abiertas",
      approvalsSubtitle: "Aprobaciones y preguntas que pidieron los colegas de IA y que aún nadie ha respondido.",
      originSpace: "Espacio",
      directRoom: "conversación directa",
      approvalKinds: { review: "aprobación", question: "pregunta" },
      schedulesTitle: "Programaciones",
      schedulesSubtitle: "Trabajo recurrente que alguien pidió en un espacio; se ejecuta hasta que alguien lo termine.",
      createdBy: "pedido por",
      lastRun: "última ejecución",
      end: "Terminar",
      confirmEnd: "¿Terminar esta programación?",
      none: "Ninguno",
      loading: "Cargando…",
      failed: "Error",
      working: "En curso…",
      done: "Hecho",
      memoryTitle: "Organización",
      memorySubtitle: "Las personas y los colegas de IA de la empresa con el ámbito de memoria en el que trabaja cada colega de IA.",
      memoryMember: "Miembro",
      area: "Área",
      decisionMaker: "Persona que decide",
      status: { running: "activo" },
    },
    core: {
      conversationTitle: 'Conversación desde el panel',
      conversationHint: 'Cada mensaje y cada respuesta se dicen también en Webex: en el hilo del trabajo del agente y, si no, en su sala directa con el bot.',
      conversationEmpty: 'Aún no hay mensajes desde el panel.',
      writeToAgent: 'Mensaje a este agente',
      answerPending: 'Respuesta pendiente',
      title: 'Veridion Core',
      subtitle: 'El sistema operativo agéntico detrás del bot de la empresa: sus agentes, sus mensajes y consumo de tokens, las definiciones, el arquitecto y la organización.',
      done: 'Hecho.',
      failed: 'No ha funcionado',
      loading: 'Cargando …',
      working: 'Procesando …',
      none: 'Ninguno.',
      unavailable: 'Veridion Core no está disponible',
      errors: {
        AGENT_FINISHED: 'El agente ha finalizado y ya no acepta mensajes',
        EMERGENCY_STOP: 'La parada de emergencia está activa',
        DEFINITION_INVALID: 'La definición no es válida',
        TOO_MANY_AGENTS: 'Hay demasiados agentes en ejecución',
        VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core no está configurado',
        MESSAGE_EMPTY: 'El mensaje está vacío',
      },
      status: {
        building: 'construyendo la imagen',
        starting: 'iniciando',
        running: 'en ejecución',
        waiting: 'en espera',
        idle: 'listo',
        paused: 'en pausa',
        completed: 'completado',
        failed: 'fallido',
        cancelled: 'cancelado',
        stopped: 'detenido',
        not_deployed: 'no desplegado',
      },
      statusLabel: 'Estado',
      owner: 'Propietario',
      definition: 'Definición',
      parent: 'Agente padre',
      tokens: 'Tokens',
      progress: 'Progreso',
      close: 'Cerrar',
      openQuestion: 'Pregunta abierta',
      result: 'Resultado',
      answerQuestion: 'Responder a la pregunta',
      sendMessage: 'Mensaje al agente',
      urgent: 'Urgente: interrumpir el paso actual',
      send: 'Enviar',
      messageSent: 'Entregado al agente.',
      commands: {
        pause: 'Pausar',
        resume: 'Reanudar',
        cancel: 'Cancelar',
        kill: 'Finalizar de inmediato',
      },
      confirmKill: '¿Finalizar de inmediato este agente y sus subagentes?',
      subAgents: 'Subagentes',
      graph: 'Grafo',
      messages: 'Mensajes',
      messageStatus: {
        queued: 'en cola',
        delivered: 'entregado',
        consumed: 'leído',
        refused: 'rechazado',
      },
      events: 'Eventos',
      containerLog: 'Registro del contenedor',
      version: 'Versión',
      activeAgents: 'Agentes activos',
      updated: 'Actualizado',
      archived: 'archivado',
      noDefinitions: 'Todavía no hay definiciones.',
      versions: 'Versiones',
      from: 'de',
      startInput: 'Entrada inicial en JSON',
      agentStarted: 'Agente iniciado.',
      startAgent: 'Iniciar agente',
      editAsJson: 'Editar como JSON',
      confirmArchive: '¿Archivar esta definición? Los agentes en ejecución siguen funcionando.',
      archive: 'Archivar',
      definitionJson: 'Definición en JSON',
      definitionJsonHint: 'Una definición en el lenguaje de grafos de Veridion. Validar muestra sus problemas y su grafo; al guardarla se almacena como nueva versión aprobada.',
      checked: 'Comprobado.',
      validate: 'Validar',
      saved: 'Guardado como nueva versión.',
      saveVersion: 'Guardar como nueva versión',
      valid: 'La definición es válida.',
      you: 'Usted',
      architect: 'Arquitecto',
      architectPlaceholder: 'Describa lo que debe hacer el agente …',
      newDesign: 'Nuevo diseño',
      unitKinds: {
        company: 'empresa',
        department: 'departamento',
        team: 'equipo',
        project: 'proyecto',
      },
      partOf: 'parte de',
      confirmRemove: '¿Eliminar esta unidad? Sus miembros pierden este ámbito.',
      remove: 'eliminar',
      addUnit: 'Añadir una unidad',
      unitId: 'ID (minúsculas, guiones)',
      unitName: 'Nombre',
      add: 'Añadir',
      addMember: 'Añadir un miembro',
      memberKinds: {
        person: 'persona (dirección de correo)',
        agent: 'agente (ID)',
        definition: 'definición (ID)',
      },
      memberId: 'Dirección de correo o ID',
      role: 'Rol',
      confirmEmergencyOn: '¿Detener ahora todos los agentes? El bot sigue respondiendo.',
      confirmEmergencyOff: '¿Liberar la parada de emergencia?',
      emergencyStop: 'Parada de emergencia',
      emergencyRelease: 'Liberar parada de emergencia',
      emergencyActive: 'la parada de emergencia está activa',
      autopilotOn: 'Activar el piloto automático',
      autopilotOff: 'Desactivar el piloto automático',
      autopilotActive: 'Piloto automático activo: Veridion Core responde por sí mismo a cada tarjeta dirigida a las personas',
      autopilotUnitsTitle: 'Piloto automático por unidad de negocio',
      autopilotUnitsHint: 'Activa o desactiva el piloto automático individualmente para cada unidad de negocio y la capa ejecutiva. El trabajo retenido nunca se toca.',
      autopilotUnitOn: 'Piloto act.',
      autopilotUnitOff: 'Piloto inact.',
      limitsBuilds: 'Compilaciones de imagen por colega y día',
      limitsDesigns: 'Diseños de agentes por colega y día',
      limitsSave: 'Fijar límites diarios',
      limitsNone: '0 = sin límite',
      confirmAutopilotOn: '¿Activar el piloto automático? El decisor propio de Veridion Core responderá de inmediato a cada tarjeta abierta y a cada nueva en pAIoneer-humans-and-bots, de forma visible en el hilo de la tarjeta.',
      confirmAutopilotOff: '¿Desactivar el piloto automático? A partir de entonces vuelven a decidir las personas.',
      model: 'Modelo',
      codingModel: 'Modelo de programación',
      modelsTitle: 'Modelos por rol',
      modelsSubtitle: 'En qué modelo piensa cada rol de Veridion Core: la cara y la dirección de la empresa, el teléfono, el arquitecto y el juez de los veredictos de requisitos. Solo pueden elegirse modelos que la pasarela enruta; vacío significa el valor por defecto de la configuración.',
      roleCoordinator: 'Coordinador (cara y dirección)',
      roleCall: 'Teléfono',
      roleArchitect: 'Arquitecto',
      roleRequirementsJudge: 'Juez de requisitos',
      roleJudge: 'Juicios del Core',
      roleEar: 'Oído del teléfono',
      roleStt: 'Oído de Webex',
      modelGroupVllm: 'vLLM (tarjeta propia)',
      modelGroupAudio: 'Audio (tarjeta propia / nube)',
      modelGroupCloud: 'OpenRouter (nube)',
      directLlmTitle: 'Acceso directo al LLM',
      directLlmSubtitle: 'Habla directamente con un vLLM o un modelo en la nube, sin bots, agentes ni Webex',
      directLlmHint: 'Acceso directo de administrador: el modelo elegido responde en crudo, contabilizado como “console”, sin lanes, roles ni herramientas.',
      directLlmModel: 'Modelo',
      directLlmSystem: 'Prompt de sistema (opcional)',
      directLlmSystemPlaceholder: 'p. ej. Eres …',
      directLlmPrompt: 'Mensaje',
      directLlmPromptPlaceholder: '¿Qué quieres preguntar directamente al modelo?',
      directLlmSend: 'Enviar',
      directLlmSending: 'Enviando …',
      directLlmUsage: '{prompt}+{completion} tokens · {cost}',
      modelCurrent: 'En uso',
      modelDefault: 'Por defecto',
      modelChosen: 'Elegido',
      modelDefaultOption: 'el valor por defecto de la configuración',
      modelNotRouted: 'no enrutado por la pasarela',
      modelSave: 'Guardar',
      engineSilver: 'Motor de la empresa (plata)',
      engineGold: 'Motor de la empresa (oro, del orquestador)',
      callsTitle: 'Llamadas telefónicas',
      callsSubtitle: 'Cada turno hablado del teléfono, contabilizado aparte del trabajo de los colegas: tokens, coste y el tiempo del oído, la mente y la voz, por colega y modelo, de los últimos 30 días y de hoy; debajo, los turnos más recientes.',
      callsTurns: 'Turnos',
      callsCalls: 'Llamadas',
      callsAvgTotal: 'Ø total ms',
      callsAvgAsr: 'Ø oído ms',
      callsAvgLlm: 'Ø mente ms',
      callsAvgTts: 'Ø voz ms',
      callsDeferred: 'Aplazados',
      callsToday: 'Hoy',
      callsWindow: 'Últimos 30 días',
      callsRecent: 'Turnos más recientes',
      callsPerson: 'Persona',
      callsRounds: 'Rondas',
      callsNone: 'Aún no hay llamadas contabilizadas.',
      unitKindExecutive: 'Nivel directivo',
      unitKindBusinessUnit: 'Unidad de negocio',
      orgSynced: 'El nivel directivo y las unidades de negocio están definidos en la organización de Veridion Core y sincronizados aquí; se cambian allí, no en esta página.',
      memory: 'Memoria',
      ready: 'listo',
      notReady: 'no listo',
      factExtraction: 'extracción de hechos activa',
      cluster: 'Acceso al clúster',
      agentsRunning: 'Agentes en ejecución',
      agentsWaiting: 'en espera',
      definitions: 'Definiciones',
      gatewayIdentity: 'Identidad en el gateway',
      gatewayTokens: 'Tokens del gateway en la ventana',
      hostedTitle: 'Agentes alojados',
      hostedSubtitle: 'Aplicaciones de IA que Veridion Core inicia y opera en contenedores propios.',
      agent: 'Agente',
      actions: 'Acciones',
      confirmHosted: '¿{action}: {agent}?',
      hostedActions: {
        start: 'iniciar',
        stop: 'detener',
        restart: 'reiniciar',
      },
      open: 'abrir',
      agentsTitle: 'Agentes',
      agentsSubtitle: 'Cada agente y subagente se ejecuta en un contenedor propio. Abra uno para enviarle mensajes o darle órdenes.',
      showFinished: 'Mostrar agentes finalizados',
      noAgents: 'No hay agentes.',
      definitionsTitle: 'Definiciones',
      definitionsSubtitle: 'Grafos de agentes aprobados con sus versiones.',
      designsTitle: 'Diseños de agentes',
      designsSubtitle: 'Cada agente que diseñó el arquitecto, para una persona o para el trabajo de un colega de IA: para qué y por qué, cada pregunta con su respuesta, las pruebas contra los escenarios, la aprobación y las ejecuciones.',
      design: 'Diseño',
      designFor: 'Para',
      designWork: 'Trabajo',
      designState: 'Estado',
      designApprovedBy: 'Aprobado por',
      designAgent: 'Agente construido',
      filterState: 'Estado',
      filterAll: 'Todos',
      filterOpen: 'Abiertos',
      filterDone: 'Terminados',
      filterFailed: 'Fallidos',
      filterCurrent: 'Activos y fallidos recientes',
      filterActive: 'Activos',
      filterFinished: 'Finalizados',
      filterPosition: 'Colega de IA',
      pagePrev: 'Anterior',
      pageNext: 'Siguiente',
      pageLabel: 'Página',
      searchLabel: 'Buscar',
      showMore: 'Mostrar más',
      noDesigns: 'Aún no se ha diseñado ningún agente.',
      designReason: 'Por qué no bastaban las herramientas',
      designRecord: 'Registro',
      designAgents: 'Agentes del diseño',
      designTestRun: 'Prueba',
      designRun: 'Ejecución',
      designStatus: { designing: 'en diseño', testing: 'en prueba', asking: 'espera respuesta', approval: 'espera aprobación', running: 'en ejecución', done: 'terminado', failed: 'fallido', cancelled: 'cancelado' },
      builtBy: 'Creado por',
      builtFor: 'Para el trabajo',
      viaCodingTask: 'a través del agente de programación',
      designTests: 'Pruebas',
      designRuns: 'Ejecuciones',
      designByPerson: 'una persona en conversación',
      diagramsTitle: 'Diagramas',
      diagramsSubtitle: 'Imágenes de flujos, arquitecturas y planes dibujadas por colegas de IA, agentes y el agente de programación, con título, leyenda y código Mermaid.',
      noDiagrams: 'Aún no hay diagramas.',
      diagramAuthor: 'Autor',
      diagramBasedOn: 'Amplía',
      diagramCode: 'Código Mermaid',
      architectTitle: 'Arquitecto',
      architectSubtitle: 'Diseñe un agente conversando. El arquitecto pregunta lo que no puede resolver por sí mismo y crea el agente solo después de su aprobación.',
      orgTitle: 'Organización',
      orgSubtitle: 'Departamentos, equipos y proyectos con sus miembros; la memoria de la empresa se comparte según esta estructura.',
      usageTitle: 'Consumo por agente',
      usageSubtitle: 'Llamadas a modelos, tokens y costes notificados de los últimos 30 días.',
      calls: 'Llamadas',
      source: 'Origen',
      gpuTokens: 'Tokens en la tarjeta gráfica',
      cloudTokens: 'Tokens en la nube',
      usageByModel: 'Por colega y modelo',
      cost: 'Coste',
    },
    memory: {
      archOverviewTitle: "Visión de la arquitectura: cómo está construida la memoria de la empresa",
      archOverviewText: "Veridion Core guarda el conocimiento de la empresa en tres capas: Neo4j como grafo de conocimiento temporal para hechos, decisiones y paquetes de trabajo, PostgreSQL para los estados transaccionales de agentes, buzones y sprints, y Qdrant para la búsqueda vectorial sobre documentos de empresa. Cada unidad de negocio trabaja en un dominio de conocimiento aislado; los resultados entre unidades circulan por entregas registradas.",
      clustersTitle: "Dominios de conocimiento de las unidades de negocio",
      clustersSubtitle: "Cada unidad de negocio trabaja en un dominio de conocimiento Neo4j delimitado; los recuentos de nodos y aristas llegan en directo de Neo4j, las descripciones del poblado inicial marcado. Un clic abre el dominio en el grafo de conocimiento.",
      clusterCode: "Código",
      clusterName: "Dominio de conocimiento",
      clusterId: "Identificador",
      clusterRoles: "Roles",
      clusterBridges: "Puentes de entrega",
      clusterPolicy: "Enfoque temático y regla de aislamiento",
      clusterCounts: "Nodos / aristas (en directo)",
      clusterInsights: "Constataciones (poblado inicial)",
      clusterOpenButton: "Abrir en el grafo de conocimiento",
      countsUnavailable: "Neo4j no accesible — sin recuento",
      researchTitle: "Archivo de investigación de IA cuántica y de frontera",
      researchSubtitle: "Publicaciones científicas fundamentales y referencias de arquitectura — filas en directo de Veridion Core; el origen de cada fila es visible.",
      researchEmpty: "Aún no hay publicaciones en el archivo.",
      researchIngestNote: "Las publicaciones nuevas las añade el colega cuántico mediante su herramienta; el panel solo lee el archivo.",
      researchPublication: "Publicación",
      researchMechanism: "Mecanismo clave",
      researchRelevance: "Relevancia para la arquitectura",
      researchOrigin: "Origen",
      researchSeeded: "poblado inicial",
      researchMotivates: "Motiva la versión",
      title: 'Memoria de la empresa',
      subtitle: 'Lo que Veridion Core guarda en Neo4j: recuerdos por ámbito, hechos con su periodo de validez y la auditoría de lo que hicieron los agentes.',
      failed: 'No ha funcionado',
      loading: 'Cargando …',
      unavailable: 'La memoria no está disponible',
      database: 'Base de datos',
      ready: 'lista',
      notReady: 'no lista',
      factExtraction: 'Extracción de hechos',
      episodesQueued: 'Episodios en espera',
      lastError: 'Último error',
      contentTitle: 'Contenido',
      contentSubtitle: 'Nodos por etiqueta y recuerdos por ámbito y tipo.',
      label: 'Etiqueta',
      count: 'Cantidad',
      empty: 'Todavía nada.',
      scope: 'Ámbito',
      kind: 'Tipo',
      kinds: {
        fact: 'hecho',
        decision: 'decisión',
        task: 'tarea',
        procedure: 'procedimiento',
        note: 'nota',
        episode: 'episodio',
      },
      searchTitle: 'Búsqueda',
      searchSubtitle: 'La recuperación que usan los agentes: significado, palabras y hechos extraídos.',
      searchPlaceholder: 'Término de búsqueda o pregunta',
      allScopes: 'todos los ámbitos',
      search: 'Buscar',
      noResults: 'No se ha encontrado nada.',
      text: 'Texto',
      validFrom: 'Válido desde',
      source: 'Fuente',
      extracted: 'extraído',
      recorded: 'registrado',
      rememberTitle: 'Recordar',
      rememberSubtitle: 'Guardar un hecho, una decisión, una tarea, un procedimiento o una nota en un ámbito.',
      remembered: 'Guardado.',
      remember: 'Recordar',
      created: 'Creado',
      validity: 'Validez',
      invalid: 'no válido',
      confirmInvalidate: '¿Marcar este recuerdo como ya no válido?',
      invalidate: 'marcar como no válido',
      forget: 'olvidar',
      confirmForget: '¿Olvidar esta entrada para siempre? Se elimina de la memoria y no se puede restaurar.',
      forgotten: 'Olvidado.',
      factsTitle: 'Hechos a lo largo del tiempo',
      factsSubtitle: 'Hechos extraídos de conversaciones y resultados de agentes; un hecho contradicho recibe una fecha de fin.',
      noFacts: 'Todavía no se han extraído hechos.',
      briefsTitle: 'Resúmenes de los colegas de IA',
      briefsSubtitle: 'Lo que cada colega de IA lee primero: compromisos abiertos, decisiones vigentes, asuntos en curso y clientes, redactado cada noche a partir de la memoria.',
      brief: 'Resumen',
      updated: 'Actualizado',
      noBriefs: 'Todavía no hay resúmenes.',
      fact: 'Hecho',
      from: 'Desde',
      to: 'Hasta',
      validUntil: 'Válido hasta',
      stillValid: 'sigue siendo válido',
      entityTitle: 'Entorno',
      entitySubtitle: 'Con qué está vinculada una tarea, un proyecto, una persona, un sistema o una entidad.',
      entityPlaceholder: 'Nombre, ID de tarea, dirección de correo o ID',
      show: 'Mostrar',
      auditTitle: 'Auditoría',
      auditSubtitle: 'Llamadas a modelos y herramientas, mensajes y subagentes iniciados.',
      auditPlaceholder: 'ID de agente (vacío: todos)',
      filter: 'Filtrar',
      time: 'Hora',
      agent: 'Agente',
      event: 'Evento',
      toolOrModel: 'Herramienta o modelo',
      status: 'Estado',
      detail: 'Detalle',
      consoleTitle: 'Consola de consultas',
      consoleSubtitle: 'Cypher de solo lectura; las sentencias de escritura se rechazan.',
      run: 'Ejecutar',
      truncated: 'se han recortado más filas',
      graph: {
        clusterPickTitle: "Enfocar un dominio de conocimiento en el grafo",
        clusterPickHint: "Un clic en una unidad de negocio enfoca su subgrafo con roles y puentes de entrega en el grafo interactivo.",
        allClusters: "Todos los dominios (grafo completo)",
        activeCluster: "Dominio de conocimiento activo",
        publicationsTitle: "Publicaciones del archivo de investigación",
        storesTitle: 'Almacenes de la memoria de la empresa',
        storesSubtitle: 'Qué contiene cada almacén de la memoria de la empresa, leído en vivo: el grafo en Neo4j, el estado de Veridion Core en Postgres, los vectores de la base de conocimiento en Qdrant.',
        storeNeo4j: 'Neo4j (grafo)',
        storeNeo4jHolds: 'La memoria de la empresa: los recuerdos con su ámbito, las entidades y los hechos extraídos por Graphiti con su periodo de validez, los elementos de trabajo con su significado, el trabajo de software y la auditoría de los agentes.',
        storePostgres: 'Postgres (relacional)',
        storePostgresHolds: 'El estado transaccional de Veridion Core: la tabla de procesos de los agentes, los buzones, las conversaciones, los puntos de control, las tareas de codificación, las aprobaciones, la organización y el consumo.',
        storeQdrant: 'Qdrant (vectores)',
        storeQdrantHolds: 'La base de conocimiento de la empresa: los pasajes vectorizados de los documentos que añadió un administrador, consultados por el orquestador cuando un turno de conversación necesita la base de conocimiento.',
        nodes: 'nodos',
        relationships: 'relaciones',
        relationshipType: 'Tipo de relación',
        tables: 'tablas',
        table: 'Tabla',
        rows: 'filas',
        purpose: 'Qué contiene',
        documents: 'documentos',
        session: 'Sesión',
        collection: 'Colección',
        role: 'Rol',
        roleDocuments: 'documentos',
        roleCurated: 'pares pregunta-respuesta revisados',
        title: 'Grafo',
        subtitle: 'El grafo de la memoria de la empresa en Neo4j: parta de un resultado de búsqueda, de los recuerdos más recientes o de los elementos de trabajo; pulse un nodo para leerlo, expanda sus vecinos, arrastre para ordenar, desplace para ampliar.',
        startNewest: 'Recuerdos más recientes',
        startWork: 'Elementos de trabajo',
        searchPlaceholder: 'Nombre, texto o id que buscar en el grafo',
        find: 'Buscar',
        noHits: 'Nada encontrado.',
        name: 'Nombre',
        sources: { memory: 'recuerdo', entity: 'entidad extraída', node: 'memoria de proyecto', episode: 'episodio' },
        show: 'mostrar',
        shown: '{nodes} nodos y {edges} relaciones en el grafo',
        truncated: 'cortado en el límite; expanda un nodo o busque con más precisión',
        selected: 'Nodo seleccionado',
        selectHint: 'Pulse un nodo del grafo.',
        expand: 'Expandir vecinos',
        expandTwo: 'Expandir dos niveles',
        centre: 'Centrar en este nodo',
        facts: 'Hechos de esta entidad',
        degree: 'Relaciones',
        direction: 'Dirección',
        out: 'saliente',
        in: 'entrante',
        noRelationships: 'Sin relaciones.',
        property: 'Propiedad',
        value: 'Valor',
        noProperties: 'Sin propiedades.',
        factsOf: 'Hechos de',
        factsSubtitle: 'Lo que Graphiti extrajo sobre esta entidad, con el periodo en que vale cada hecho; un hecho contradicho lleva fecha de fin.',
        relation: 'Relación',
        other: 'Otra entidad',
        newestTitle: 'Recuerdos más recientes',
        newestSubtitle: 'Los últimos recuerdos escritos, con su asunto; «mostrar» dibuja uno con sus enlaces.',
        about: 'Asunto',
        workTitle: 'Elementos de trabajo',
        workSubtitle: 'Cada trabajo confirmado con su estado, responsable, incidencia y los resultados de sus escenarios; «mostrar» dibuja uno con su significado, su incidencia, sus tareas de codificación y los agentes construidos para él.',
        allStates: 'todos los estados',
        states: { confirmed: 'confirmado', in_progress: 'en curso', blocked: 'bloqueado', done: 'terminado', failed: 'fallido', dropped: 'descartado' },
        workItem: 'Elemento de trabajo',
        owner: 'Responsable',
        issue: 'Incidencia',
        scenarios: 'Escenarios',
        results: { passed: 'superado', failed: 'fallido', pending: 'pendiente' },
      },
      day: {
        title: 'La jornada de la empresa',
        subtitle: 'La cronología de eventos que registra Veridion Core: las palabras de las personas, tarjetas, trabajo, traspasos, investigaciones, agentes, tareas de codificación, proyectos, incidencias y reuniones, lo más reciente primero.',
        sinceToday: 'hoy',
        sinceDay: 'últimas 24 horas',
        sinceWeek: 'últimos 7 días',
        allKinds: 'todos los tipos',
        refresh: 'Actualizar',
        count: '{n} eventos',
        time: 'Hora',
        actor: 'Actor',
        happening: 'Evento',
        work: 'Trabajo',
        empty: 'Nada registrado en este periodo.',
        kinds: { word: 'palabra', request: 'solicitud', card: 'tarjeta', work: 'trabajo', handover: 'traspaso', research: 'investigación', agent: 'agente', task: 'tarea de codificación', project: 'proyecto', incident: 'incidencia', schedule: 'programación', meeting: 'reunión', message: 'mensaje' },
      },
    },
    title: 'Panel de administración',
    adminKicker: 'Operaciones',
    smtmStatusTitle: 'Datos y previsiones de SMTM',
    smtmStatusSubtitle: 'Supervisa las series temporales del broker, los modelos publicados, la salida de predicción y los feeds RSS.',
    smtmStatusUnavailable: 'Estado de SMTM no disponible',
    smtmGeneratedAt: 'Generado el',
    smtmMinimumRows: 'Filas mínimas de entrenamiento',
    smtmBaseFrames: 'Series temporales base',
    smtmTrainableFrames: 'Datos brutos listos',
    smtmWaitingHistory: 'Esperando histórico',
    smtmPredictionTrackedInstruments: 'Instrumentos supervisados',
    smtmPredictionEnabledCount: 'Predicciones activas',
    smtmPredictionDisabledCount: 'Predicciones en pausa',
    smtmMlFrames: 'Conjuntos de datos ML',
    smtmOnlineModels: 'Modelos en línea',
    smtmModelsWithArtifacts: 'Modelos con artefactos',
    smtmPredictionFrames: 'Series de predicción',
    smtmMissingPredictions: 'Series sin predicciones',
    smtmBlobArtifacts: 'Artefactos blob',
    smtmStalePredictions: 'Predicciones obsoletas',
    smtmRssFrames: 'Feeds RSS',
    smtmDataframesTotal: 'Conjuntos de datos totales',
    smtmLatestModelUpload: 'Última subida de modelo',
    smtmLatestPredictionWrite: 'Última escritura de predicción',
    smtmRuntimeHints: 'Avisos de ejecución',
    smtmNoHints: 'No hay avisos abiertos de SMTM.',
    smtmInstrument: 'Instrumento',
    smtmBaseData: 'Datos base',
    smtmMlFrame: 'Conjunto de datos ML',
    smtmModelPublish: 'Estado del modelo',
    smtmArtifacts: 'Artefactos',
    smtmPredictionFrame: 'Serie de predicción',
    smtmIssues: 'Incidencias',
    smtmNoIssues: 'Sin incidencias',
    smtmNoFrames: 'No se han encontrado instrumentos SMTM.',
    smtmPredictionControlTitle: 'Control de predicción SMTM',
    smtmPredictionControlSubtitle: 'Decida por instrumento si SMTM debe calcular nuevas predicciones de aprendizaje automático o solo seguir recopilando datos base.',
    smtmPredictionSettingsUnavailable: 'Control de predicción SMTM no disponible',
    smtmPredictionControlHint: 'Los instrumentos en pausa conservan sus datos históricos. Ya no se generan para ellos nuevos conjuntos ML, entrenamientos ni predicciones.',
    smtmPredictionMode: 'Modo de predicción',
    smtmPredictionToggle: 'Control de administración',
    smtmPredictionToggleLabel: 'Activar o pausar predicciones',
    smtmPredictionEnabled: 'Predicción activa',
    smtmPredictionDisabled: 'Predicción en pausa',
    smtmPredictionSaving: 'Guardando...',
    smtmPredictionSettingsSaved: 'Control de predicción SMTM guardado.',
    smtmPredictionSaveChanges: 'Guardar cambios',
    smtmPredictionResetChanges: 'Descartar cambios',
    smtmPredictionPendingChanges: 'cambios pendientes',
    smtmPredictionPendingBadge: 'Pendiente de guardar',
    smtmOpenAzuriteUi: 'Abrir la interfaz web de Azurite',
    azuriteTitle: 'Interfaz web de Azurite (SMTM)',
    azuriteSubtitle: 'Vista de solo lectura de las entradas de modelstatus, los artefactos blob y las descargas de modelos.',
    azuriteModelGroups: 'Grupos de modelos',
    azuriteBlobArtifacts: 'Artefactos blob',
    azuriteFiles: 'Archivos',
    azuriteSearchPlaceholder: 'Filtrar modelos',
    azuriteNoModels: 'No se han encontrado modelos en Azurite.',
    smtmRows: 'Filas',
    smtmLatest: 'Última marca de tiempo',
    smtmAge: 'Antigüedad',
    smtmValue: 'Valor',
    smtmMinutesAgo: 'min atrás',
    smtmMinutesAhead: 'min por delante',
    smtmHoursAgo: 'h atrás',
    smtmDaysAgo: 'd atrás',
    smtmStateLabels: {
      available: 'Disponible',
      trainable: 'Entrenable',
      waiting_for_history: 'Esperando histórico',
      missing_base_data: 'Sin datos base',
      missing_machine_learning: 'Falta el conjunto de datos ML',
      missing_prediction: 'Falta la predicción',
      prediction_disabled: 'Predicción en pausa',
      stale_prediction: 'Predicción obsoleta',
      open: 'Abierta',
      completed: 'Completada',
      online: 'En línea',
      offline: 'Fuera de línea',
      training: 'Entrenando',
      uploading: 'Subiendo',
      failed: 'Fallida',
      unknown: 'Desconocida',
      missing: 'Ausente'
    },
    smtmIssueLabels: {
      empty_base_frame: 'Serie temporal base vacía',
      insufficient_history: 'Histórico insuficiente',
      missing_machine_learning_frame: 'Falta el conjunto de datos ML',
      missing_prediction_frame: 'Falta la serie de predicción',
      stale_prediction_frame: 'Serie de predicción obsoleta',
      missing_online_model: 'Sin modelo en línea',
      model_offline: 'Modelo fuera de línea',
      missing_model_blob: 'Falta el blob del modelo',
      missing_model_header: 'Falta la cabecera del modelo',
      missing_modelstatus_entry: 'Falta la entrada de modelstatus',
      inference_not_writing_prediction: 'La inferencia no escribe predicciones',
      prediction_disabled_by_admin: 'Predicción pausada por el administrador'
    },
    smtmHintLabels: {
      trainable_frames_missing_predictions: 'instrumentos con datos listos y sin salida de predicción',
      instruments_waiting_for_history: 'instrumentos que siguen esperando histórico',
      models_missing_artifacts: 'modelos en línea sin artefactos completos',
      no_online_models: 'No hay modelos en línea en Azurite',
      azurite_unavailable: 'El estado del almacenamiento de Azurite no está disponible por ahora'
    },
    mailTitle: 'Configuración de correo',
    usersTitle: 'Gestión de usuarios',
    usersSubtitle: 'Cuentas, roles, estado y 2FA desde Keycloak. Al seleccionar una se abren los controles de esa cuenta.',
    usersHideCreate: 'Cerrar formulario',
    usersCreateHint: 'Una cuenta nueva empieza con 2FA obligatoria y se activa en cuanto se configura.',
    usersFilterAllStatus: 'Todos los estados',
    usersFilterAllRoles: 'Todos los roles',
    usersManage: 'Gestionar',
    usersClose: 'Cerrar',
    usersNoneFound: 'No se han encontrado usuarios.',
    usersPagePrev: 'Anterior',
    usersPageNext: 'Siguiente',
    auditTitle: 'Registro de auditoría',
    smtpHost: 'Servidor SMTP',
    smtpPort: 'Puerto SMTP',
    smtpSecurity: 'Seguridad SMTP',
    smtpUsername: 'Usuario SMTP',
    smtpPassword: 'Contraseña SMTP',
    fromEmail: 'Correo del remitente',
    fromName: 'Nombre del remitente',
    replyToEmail: 'Correo de respuesta',
    saveMailSettings: 'Guardar configuración de correo',
    sendTestMail: 'Enviar correo de prueba',
    createUser: 'Crear usuario',
    setPassword: 'Definir contraseña',
    setRoles: 'Definir roles',
    setStatus: 'Definir estado',
    resetMfa: 'Restablecer 2FA',
    revokeSessions: 'Revocar sesiones',
    filterUsers: 'Filtrar usuarios',
    testRecipient: 'Destinatario del correo de prueba',
    statusConfigured: 'Configurado',
    statusMissing: 'Sin configurar',
    userEmail: 'Correo',
    userName: 'Nombre de usuario',
    userRoles: 'Roles',
    userStatus: 'Estado',
    auditEvent: 'Evento',
    auditCreatedAt: 'Creado el',
    auditDetails: 'Detalles',
    aiGatewayTitle: 'AI Gateway',
    aiGatewayEndpoint: 'Endpoint',
    aiGatewayIdentitySource: 'Identidad desde el claim del token',
    aiGatewayBudgetSource: 'Valores iniciales en',
    aiGatewayModels: 'Modelos enrutados',
    aiGatewayModel: 'Modelo',
    aiGatewayBackend: 'Backend',
    aiGatewayBudgets: 'Presupuestos de tokens',
    aiGatewayIdentity: 'Identidad',
    aiGatewayTokenBudget: 'Presupuesto de tokens',
    aiGatewayWindow: 'Ventana',
    aiGatewayAnyIdentity: 'cualquier identidad',
    aiGatewayAnyModel: 'cualquier modelo',
    aiUsageWindowStarted: 'Ventana desde',
    aiUsageRemaining: 'Restante',
    aiUsageIdentities: 'Identidades',
    aiGatewaySubtitle: 'El Envoy AI Gateway es la única vía hacia un modelo: los modelos enrutados, sus backends de servicio y el presupuesto de tokens de cada identidad.',
    aiGatewayHint: 'Los presupuestos se operan aquí. La capa de despliegue solo siembra los valores para un clúster nuevo.',
    aiUsageTitle: 'Consumo de IA por identidad',
    aiUsageSubtitle: 'Tokens consumidos y contabilizados por el gateway en la ventana en curso.',
    sessionActiveUsers: 'Usuarios conectados',
    sessionActiveSessions: 'Sesiones activas',
    sessionMfaSessions: 'Sesiones verificadas',
    aiUsageTotalTokens: 'Tokens totales',
    aiServicesTitle: 'Accesos a servicios',
    aiServicesSubtitle: 'Enlaces a las superficies de API y de operación de la plataforma; cada destino comprueba por sí mismo el rol de administrador.',
    aiMailSubtitle: 'La configuración SMTP con la que Keycloak envía los correos de verificación y restablecimiento, y el envío de prueba.',
    tabOverview: 'Resumen',
    tabSmtm: 'SMTM',
    tabEnvoy: 'Envoy AI Gateway',
    tabMail: 'Envío de correo',
    tabUsers: 'Usuarios',
    tabAudit: 'Registro de auditoría',
    tabServiceLinks: 'Accesos a servicios',
    tabVeridion: 'Veridion SMTM',
    tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
    tabAgenticRag: 'Agentic RAG',
    tabPlatform: 'Plataforma',
    platformTitle: 'Estado de la plataforma',
    platformSubtitle: 'Cada carga de trabajo de pAIoneer Labs GmbH con sus réplicas listas, reinicios e imagen, directamente desde Kubernetes.',
    platformHostPage: 'Gestionar instancias en el host de aplicaciones',
    openVisitorMonitoring: 'Abrir monitoreo de visitantes, marketing y SEO',
    platformUnavailable: 'Estado de la plataforma no disponible',
    platformWorkloadsTotal: 'Cargas de trabajo',
    platformDegradedTotal: 'No listas',
    platformRestartsTotal: 'Reinicios',
    platformWorkload: 'Carga de trabajo',
    platformNamespace: 'Espacio de nombres',
    platformReplicas: 'Réplicas',
    platformRestarts: 'Reinicios',
    platformImage: 'Imagen',
    platformState: 'Estado',
    platformStateReady: 'Lista',
    platformStateDegraded: 'Degradada',
    platformStateDown: 'Caída',
    platformStateUnknown: 'Desconocida',
    platformNodes: 'Nodos',
    platformOsImage: 'Sistema operativo',
    platformKernel: 'Kernel',
    platformRuntime: 'Runtime de contenedores',
    platformKubelet: 'Kubelet',
    platformUsed: 'En uso ahora',
    platformReportedCapacity: 'Reportado por Kubernetes',
    platformConfiguredCap: 'Límite configurado del contenedor',
    platformPressure: 'Condiciones de presión',
    platformPressureNone: 'ninguna',
    platformCpu: 'Núcleos de CPU',
    platformNoWorkloads: 'Este espacio de nombres contiene objetos de configuración, sin cargas de trabajo.',
    platformMemory: 'Memoria',
    platformEvents: 'Avisos recientes',
    platformEventsNone: 'Sin avisos.',
    platformEventObject: 'Objeto',
    platformEventReason: 'Motivo',
    platformEventMessage: 'Mensaje',
    platformEventLastSeen: 'Visto por última vez',
    platformMetricsMissing: 'No hay datos de consumo: metrics-server no responde.',
    aiGatewayBackends: 'Backends de servicio',
    gpuTitle: 'Tarjeta gráfica',
    gpuNote: 'Carga de los motores en la tarjeta gráfica, los tokens tomados de ellos por identidad y por bot de Webex, y los presupuestos de tokens por identidad y motor.',
    gpuTokensWindow: 'Tokens en la tarjeta gráfica en la ventana',
    gpuSinceStart: 'desde el inicio del motor',
    gpuIdentities: 'Por identidad, ventana en curso',
    gpuBots: 'Por bot de Webex y agente, 30 días',
    gpuBot: 'Bot de Webex / agente',
    gpuBudgetTitle: 'Presupuesto por identidad para el motor',
    gpuBudgetSet: 'Fijar presupuesto',
    gpuBudgetHint: 'Tokens por hora en el motor; la pasarela lo aplica. También acota una identidad sin límite.',
    gpuNoneYet: 'Nada contabilizado todavía.',
    gpuEngines: 'Motores',
    gpuEngine: 'Motor',
    gpuEngineGold: 'Motor Oro',
    agenticRagTitle: 'Agentic RAG',
    agenticRagSubtitle: 'Tiempo de ejecución, base de conocimiento, preparación del entrenamiento y trazabilidad de la aplicación Agentic RAG.',
    agenticRagBackendStatus: 'Estado del backend',
    agenticRagRuntimeMode: 'Modo de ejecución',
    agenticRagKnowledgeMode: 'Modo de conocimiento',
    agenticRagDeploymentEnv: 'Entorno de despliegue',
    agenticRagVectorStores: 'Almacenes vectoriales',
    agenticRagQdrantStatus: 'Qdrant',
    agenticRagQdrantCollection: 'Colección de documentos',
    agenticRagQdrantCuratedCollection: 'Colección de preguntas y respuestas curadas',
    agenticRagQdrantDashboard: 'Panel',
    agenticRagPhoenixStatus: 'Phoenix',
    agenticRagOpenDocs: 'Abrir Swagger',
    agenticRagOpenPhoenix: 'Abrir Phoenix',
    agenticRagOpenQdrant: 'Abrir Qdrant',
    agenticRagKnowledgeTitle: 'Base de conocimiento',
    agenticRagKnowledgeSubtitle: 'Estado de los documentos y de las preguntas y respuestas curadas de la aplicación Agentic RAG.',
    agenticRagDocuments: 'Documentos',
    agenticRagCuratedQaPairs: 'Pares de pregunta y respuesta curados',
    agenticRagTrainingTitle: 'Preparación del entrenamiento',
    agenticRagTrainingSubtitle: 'La última ejecución del generador y el último estado del entrenador.',
    agenticRagLatestDataset: 'Último conjunto de datos',
    agenticRagDatasetPairs: 'Pares de pregunta y respuesta',
    agenticRagDatasetDocuments: 'Documentos procesados',
    agenticRagDatasetModifiedAt: 'Última modificación',
    agenticRagLatestTrainerInput: 'Última entrada del entrenador',
    agenticRagTrainerInputModifiedAt: 'Entrada modificada',
    agenticRagLatestTrainerRun: 'Última ejecución del entrenador',
    agenticRagTrainerRunModifiedAt: 'Resumen de la ejecución modificado',
    gpuEngineSilver: 'Motor Plata',
    gpuAssignment: 'Asignación',
    gpuWho: 'Quién',
    gpuRank: 'Rango',
    gpuRankHint: 'El rango 0 se atiende primero; cada motor atiende por rango.',
    gpuLanes: 'Llamadas de Veridion Core en curso por motor y rango',
    gpuInFlight: 'en curso',
    gpuWhoMainBotPeople: 'Bot principal: conversaciones con personas',
    gpuWhoMainBotJudgements: 'Bot principal: juicios en el mismo turno',
    gpuWhoAutopilot: 'Piloto automático',
    gpuWhoAgents: 'Agentes que ejecuta el bot principal',
    gpuWhoArchitect: 'Arquitecto',
    gpuWhoChair: 'Presidencia de la reunión',
    gpuWhoOrchestrator: 'Orquestador de la instancia de la empresa',
    gpuWhoColleagues: 'Colegas de IA: turnos y sus juicios',
    gpuWhoMeetingWords: 'Colegas de IA: intervenciones en reuniones',
    gpuWhoBackgroundReading: 'Servicio en segundo plano: lectura de las publicaciones de los bots',
    gpuWhoMemory: 'Memoria de la empresa: admisión y resúmenes',
    gpuWhoCoding: 'Tareas de código: juicios y aprendizaje',
    gpuWhoResearch: 'Investigación web y OSINT',
    gpuWhoKnowledgeBase: 'Base de conocimiento de la empresa: lectura de páginas escaneadas',
    gpuWhoPipeline: 'Revisión de la pipeline contra la IDD',
    gpuWhoSmtm: 'Veridion SMTM: el chat y la base de conocimiento del SaaS, último rango',
    gpuUnavailable: 'La tarjeta gráfica no responde',
    aiGatewaySource: 'Origen',
    aiSourceGpu: 'Tarjeta gráfica',
    aiGatewayMeter: 'Contador',
    aiGatewayMeterIdentity: 'Cada identidad, contada',
    aiGatewayEngines: 'Motores en la tarjeta gráfica',
    aiGatewayEnginesHint: 'Cifras en vivo de cada motor a partir de sus métricas: solicitudes en curso y en espera, ocupación de la caché y tokens servidos desde el inicio.',
    aiEngineRunning: 'En curso',
    aiEngineWaiting: 'En espera',
    aiEngineCache: 'Caché ocupada',
    aiEngineServed: 'Tokens servidos',
    aiEngineIdle: 'Sin solicitudes',
    aiEngineUnavailable: 'El motor no responde',
    aiGatewayServing: 'Listo',
    aiBudgetControlTitle: 'Operar presupuestos de tokens',
    aiBudgetControlSubtitle: 'El presupuesto por defecto se aplica a todas las identidades. Una identidad concreta puede tener su propio límite.',
    aiBudgetDefault: 'Presupuesto por defecto',
    aiBudgetIdentity: 'Identidad',
    aiBudgetTokens: 'Tokens',
    aiBudgetApply: 'Aplicar',
    aiBudgetAdd: 'Definir límite',
    aiBudgetRemove: 'Quitar',
    aiBudgetSaved: 'Presupuesto de tokens aplicado.',
    aiBudgetIdentityPlaceholder: 'Id de cliente, p. ej. paioneer-agent-veridion-smtm',
    aiBudgetUnlimited: 'Sin límite',
    aiBudgetSetUnlimited: 'Quitar el límite',
    aiBudgetRestoreLimit: 'Restablecer el límite',
    aiUsageReset: 'Vaciar ventana',
    aiUsageResetDone: 'Ventana en curso vaciada.',
    userMfa: '2FA',
    userMfaOn: 'Configurada',
    userMfaOff: 'Ausente',
    userCreatedAt: 'Creado',
    mailSource: 'Gestionado en',
    veridionTitle: 'Veridion SMTM',
    veridionSubtitle: 'Núcleo conversacional del asistente de trading: ejecución, registro de herramientas, servidores MCP y actividad.',
    veridionOpenPage: 'Abrir Veridion',
    veridionOpenDocs: 'Abrir Swagger',
    veridionCoreStatus: 'Veridion MCP orchestrator',
    veridionTools: 'Herramientas',
    veridionToolsTitle: 'Registro de herramientas',
    veridionToolsSubtitle: 'Muestra las familias de herramientas cargadas y su estado efectivo.',
    veridionToolName: 'Herramienta',
    veridionToolRuntime: 'Runtime',
    veridionToolRisk: 'Riesgo',
    veridionToolEnabled: 'Activada',
    veridionNoTools: 'No hay herramientas de Veridion cargadas.',
    veridionRuntimeProfiles: 'Perfiles de runtime',
    veridionRegistryReloaded: 'Registro recargado',
    veridionProvider: 'Ruta de IA',
    veridionMcpTitle: 'Servidores MCP',
    veridionMcpSubtitle: 'Servidores de herramientas externos conectados, con su estado y su número de herramientas.',
    veridionMcpServer: 'Servidor',
    veridionMcpState: 'Estado',
    veridionMcpTools: 'Herramientas',
    veridionMcpLastSuccess: 'Último contacto',
    veridionMcpConnected: 'conectado',
    veridionMcpUnreachable: 'inaccesible',
    veridionMcpDisabled: 'desactivado',
    veridionMcpEmpty: 'No hay servidores MCP configurados.',
    veridionActivityTitle: 'Actividad',
    veridionActivitySubtitle: 'Eventos de ejecución estructurados del orquestador y sus herramientas.',
    veridionActivityEmpty: 'Todavía no se ha registrado actividad.',
    veridionActivitySource: 'Origen',
    veridionActivitySurface: 'Superficie',
    veridionActivityEvent: 'Evento',
    veridionActivityTool: 'Herramienta',
    veridionActivityStatus: 'Estado',
    veridionActivitySummary: 'Resumen',
    veridionUnavailable: 'Veridion no está disponible por ahora.',
    veridionNotConfigured: 'Veridion aún no está completamente configurado en el runtime de la Homepage.',
    veridionRequestFailed: 'Veridion no completó correctamente la llamada de administración solicitada.',
    companyTitle: 'Veridion pAIoneer Labs GmbH',
    companySubtitle: 'La instancia de Veridion de pAIoneer Labs GmbH para su personal en Webex, con YouTrack y su propia base de conocimiento; sus llamadas a modelos pasan por el Envoy AI Gateway.',
    companyWorkloads: 'Cargas de trabajo',
    companyTokensWindow: 'Tokens en la ventana actual',
    companyBudget: 'Presupuesto',
    companyBudgetDefault: 'presupuesto predeterminado',
    companyCost30: 'Coste de los últimos 30 días',
    openrouterTitle: 'Facturado por OpenRouter',
    openrouterRemaining: 'Crédito restante',
    openrouterOf: 'de',
    openrouterToday: 'Hoy',
    openrouterWeek: 'Esta semana',
    openrouterMonth: 'Este mes',
    openrouterUnavailable: 'OpenRouter no se puede leer ahora',
    openrouterNote: 'La facturación de OpenRouter para la clave de la plataforma, en dólares estadounidenses; día y semana en UTC. Los valores registrados abajo solo cuentan respuestas que indican su coste y por eso son menores.',
    companyRequests30: 'Llamadas al modelo de los últimos 30 días',
    companyCostNote: 'Coste en dólares estadounidenses tal como lo informa OpenRouter por solicitud; Envoy AI Gateway asigna los tokens a la identidad {identity}.',
    companyCostNotReported: 'no informado',
    companyPartUnavailable: 'inaccesible',
    companyWebexTitle: 'Bot de Webex',
    companyWebexSubtitle: 'Webex llama a webex.paioneer-labs.eu/hook; el puente comprueba la firma y el remitente y solo pasa a Veridion los mensajes permitidos.',
    companyWebexBot: 'Bot',
    companyWebexWebhook: 'Webhook',
    companyWebexRegistered: 'registrado',
    companyWebexNotRegistered: 'no registrado',
    companyWebexAccess: 'Permitidos',
    companyWebexAnswered: 'Respondidos',
    companyWebexRejected: 'Rechazados',
    companyWebexFailed: 'Fallidos',
    companyWebexRecent: 'Entregas recientes',
    companyWebexTime: 'Hora',
    companyWebexOutcome: 'Resultado',
    companyWebexReason: 'Motivo',
    companyWebexSender: 'Remitente',
    companyWebexEmpty: 'Ninguna entrega desde el último inicio.',
    companyWebexNotConfigured: 'El puente de Webex no está accesible o falta su clave de estado en la API de administración.',
    companyUsageTitle: 'Uso por persona',
    companyUsageSubtitle: 'Llamadas al modelo, tokens y coste de los últimos 30 días según el registro de uso de la instancia.',
    companyUsagePerson: 'Persona',
    companyUsageCalls: 'Llamadas',
    companyUsageTokens: 'Tokens',
    companyUsageCost: 'Coste (USD)',
    companyUsageEmpty: 'No hubo llamadas al modelo en los últimos 30 días.',
    companyWebexSendTitle: 'Escribir como el bot',
    companyWebexSendPerson: 'A una persona',
    companyWebexSendRoom: 'En un espacio del bot',
    companyWebexSendEmail: 'Correo electrónico en Webex',
    companyWebexSendText: 'Mensaje (Markdown)',
    companyWebexSendButton: 'Enviar',
    companyWebexSendDone: 'Enviado.',
    companyWebexSendFailed: 'Error',
    companyWebexRooms: 'Espacios del bot',
    companyWebexRoomGroup: 'grupo',
    companyWebexRoomDirect: 'directo',
    companyWebexRoomsEmpty: 'El bot aún no está en ningún espacio.',
    companyKnowledgeTitle: 'Base de conocimiento',
    companyKnowledgeSubtitle: 'Los documentos de la base de conocimiento de la instancia de la empresa (Agentic RAG); el orquestador los consulta cuando un turno los necesita. Phoenix registra cada búsqueda.',
    companyKnowledgeDocument: 'Documento',
    companyKnowledgeSize: 'Tamaño',
    companyKnowledgeModified: 'Añadido',
    companyKnowledgeDelete: 'Quitar',
    companyKnowledgeDeleteConfirm: '¿Quitar {name} de la base de conocimiento?',
    companyKnowledgeUpload: 'Añadir documento',
    companyKnowledgeUploading: 'Subiendo …',
    companyKnowledgeIntake: 'Incorporación',
    companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
    companyKnowledgeEmpty: 'La base de conocimiento está vacía.',
    companyKnowledgeNotConfigured: 'La base de conocimiento no está conectada a la API de administración.',
    companyGuestsTitle: 'Invitados con acceso',
    companyGuestsHint: 'Cualquier dirección de {domains} puede usar el bot. Los administradores añaden aquí direcciones externas sueltas; el cambio se aplica al momento.',
    companyGuestsEmail: 'Dirección de correo',
    companyGuestsAdd: 'Añadir',
    companyGuestsRemove: 'Quitar',
    companyGuestsRemoveConfirm: '¿Retirar a {email} el acceso al bot?',
    companyGuestsAddedBy: 'Añadido por',
    companyGuestsAddedAt: 'Añadido el',
    companyGuestsEmpty: 'No hay invitados.',
    companyGuestsNotPersistent: 'La lista no se guarda: el puente no tiene directorio de datos.',
    companyGuestsLoadFailed: 'La lista guardada no se pudo leer; ningún invitado tiene acceso hasta el próximo cambio.',
    companyErrorRecipientNotAllowed: 'Esta dirección no puede responder al bot. Añádala primero como invitado y luego envíe.',
    companyErrorDomainAllowed: 'Las direcciones de este dominio ya tienen acceso.',
    companyErrorInvalidEmail: 'No es una dirección de correo válida.',
    companyErrorAlreadyListed: 'Esta dirección ya está en la lista.',
    companyErrorStoreUnwritable: 'No se pudo guardar la lista.',
    smtmFilterTitle: 'Filtro de instrumentos SMTM',
    smtmFilterSubtitle: 'Una entrada vacía muestra todos los instrumentos; varios nombres de instrumento se separan por comas, por ejemplo EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
    smtmFilterPlaceholder: 'Nombres de instrumentos, separados por comas',
    smtmFilterApply: 'Aplicar filtro',
    smtmFilterClear: 'Limpiar filtro',
    smtmReportingTitle: 'Informe de señales SMTM',
    smtmReportingSubtitle: 'Muestra las señales de compra cualificadas, su evaluación de salida y el estado de entrega de las notificaciones automáticas.',
    smtmReportingUnavailable: 'Informe de SMTM no disponible',
    smtmReportingQualifiedSignals: 'Señales cualificadas',
    smtmReportingOpenSignals: 'Señales abiertas',
    smtmReportingResolvedSignals: 'Señales resueltas',
    smtmReportingWins: 'Aciertos',
    smtmReportingLosses: 'Fallos',
    smtmReportingWinRate: 'Tasa de acierto',
    smtmReportingAverageActualReturn: 'Retorno real medio',
    smtmReportingNetActualReturn: 'Retorno real neto',
    smtmReportingDeliveryFailed: 'Entregas fallidas',
    smtmReportingEntryTime: 'Hora de entrada',
    smtmReportingExitTime: 'Hora de salida',
    smtmReportingExpectedReturn: 'Retorno esperado',
    smtmReportingActualReturn: 'Retorno real',
    smtmReportingSignalStatus: 'Estado de la señal',
    smtmReportingNoSignals: 'Todavía no hay señales cualificadas almacenadas.',
    smtmReportingPendingDeliveries: 'Entregas pendientes',
    smtmReportingFailedDeliveries: 'Entregas fallidas',
    smtmReportingDeliveryError: 'Error de entrega',
    smtmTrainingTitle: 'Entrenamiento y modelos SMTM',
    smtmTrainingSubtitle: 'Muestra la calidad del entrenamiento, el estado de los modelos y los artefactos publicados por el servicio de entrenamiento.',
    smtmTrainingUnavailable: 'Entrenamiento SMTM no disponible',
    smtmTrainingModels: 'Modelos',
    smtmTrainingOnlineModels: 'Modelos en línea',
    smtmTrainingFailedModels: 'Modelos fallidos',
    smtmTrainingStaleModels: 'Modelos obsoletos',
    smtmTrainingAverageMae: 'MAE medio',
    smtmTrainingAverageRmse: 'RMSE medio',
    smtmTrainingAverageR2: 'R² medio',
    smtmTrainingAverageMase: 'MASE medio',
    smtmTrainingAverageHitRate: 'Acierto de dirección medio',
    smtmTrainingHitRate: 'Acierto de dirección',
    smtmTrainingLastSuccess: 'Último entrenamiento correcto',
    smtmTrainingResolution: 'Resolución / horizonte',
    smtmTrainingConsoleTitle: 'Consola de entrenamiento SMTM',
    smtmTrainingConsoleSubtitle: 'Seguimiento en vivo de la salida del servicio de entrenamiento.',
    smtmTrainingConsoleUnavailable: 'Consola de entrenamiento SMTM no disponible',
    smtmTrainingConsoleEmpty: 'Todavía no hay salida de entrenamiento.',
    smtmRuntimeTitle: 'Runtime de SMTM',
    smtmRuntimeSubtitle: 'Horizonte global, estado de reconstrucción y compuerta de predicción del sistema SMTM en vivo.',
    smtmRuntimeUnavailable: 'Runtime de SMTM no disponible',
    smtmRuntimeForecastHorizon: 'Horizonte de previsión',
    smtmRuntimeResolution: 'Resolución',
    smtmRuntimeConfigVersion: 'Versión de configuración',
    smtmRuntimePredictionGate: 'Compuerta de predicción',
    smtmRuntimeRebuild: 'Reconstrucción',
    smtmRuntimeStateOpen: 'abierta',
    smtmRuntimeStateClosed: 'cerrada',
    smtmRuntimeStateActive: 'activa',
    smtmRuntimeStateIdle: 'inactiva',
    smtmRuntimeForecastHorizonMinutes: 'Minutos del horizonte de previsión',
    smtmRuntimeResolutionMinutes: 'Minutos de resolución',
    smtmRuntimeRequireCompletedBars: 'Exigir velas completas',
    smtmRuntimePredictionGateOpen: 'Compuerta de predicción abierta',
    smtmRuntimeRebuildActive: 'Reconstrucción activa',
    smtmRuntimeSaving: 'Guardando runtime...',
    smtmRuntimeSave: 'Guardar ajustes del runtime',
    smtmRuntimeReset: 'Descartar cambios del runtime',
    smtmRuntimeSaved: 'Ajustes del runtime de SMTM guardados.',
    smtmTrainingRows: 'Filas de entrenamiento / prueba',
    smtmTrainingMetrics: 'Métricas',
    smtmTrainingIssues: 'Incidencias de entrenamiento',
    smtmTrainingLlmFeatures: 'Características LLM',
    smtmTrainingNoModels: 'Todavía no hay modelos de entrenamiento en caché.',
    smtmDirection: 'Dirección',
    smtmSentiment: 'Sentimiento',
    smtmDeliveryStage: 'Fase',
    smtmDeliveryRecipient: 'Destinatario',
    mailSettingsSaved: 'Configuración de correo guardada.',
    mailTestSent: 'Correo de prueba enviado.',
    userCreatedSuccess: 'Usuario creado correctamente.',
    userUpdatedSuccess: 'Usuario actualizado correctamente.',
    userDeletedSuccess: 'Usuario eliminado correctamente.',
    deleteUser: 'Eliminar usuario',
    roleLabels: {
      admin: 'Administrador',
      pro: 'Pro',
      tester: 'Probador',
      user: 'Usuario'
    },
    statusLabels: {
      pending_email_verification: 'Verificación de correo pendiente',
      pending_mfa: '2FA pendiente',
      active: 'Activo',
      locked: 'Bloqueado',
      disabled: 'Desactivado'
    }
  },
  footer: {
    managingDirectors: 'Directores generales',
    servicesTitle: 'Servicios',
    legal: {
      title: 'Información legal',
      imprint: 'Aviso legal',
      privacy: 'Política de privacidad',
      aiTransparency: 'Transparencia en materia de IA',
      cookieSettings: 'Configuración de cookies',
      terms: 'Condiciones del servicio'
    },
    copyright: 'Todos los derechos reservados.'
  },
  auth: {
    validating: 'Validando...',
    errors: {
      registrationFailed: 'Error en el registro: ',
      unknownError: 'Error desconocido'
    }
  },
  account: {
    username: 'Nombre de usuario',
    email: 'Correo electrónico',
    roles: 'Roles',
    manageText: 'La contraseña, la autenticación de dos factores, las sesiones activas y la dirección de correo electrónico se gestionan en la administración de la cuenta.',
    manageButton: 'Abrir la administración de la cuenta',
    signedOut: 'No has iniciado sesión.'
  },
  cookies: {
    title: 'Configuración de privacidad',
    description: 'Analizamos las estadísticas de visitas con métodos de aprendizaje automático para mejorar nuestro sitio web. Con su consentimiento tratamos para ello datos de uso y del dispositivo, incluida su dirección IP, y reconocemos su navegador en visitas posteriores. El consentimiento es voluntario y puede retirarse en cualquier momento en «{settings}». Los detalles, también sobre las transferencias a terceros países, figuran en la política de privacidad.',
    necessary: {
      title: 'Necesarias',
      description: 'Imprescindibles para el funcionamiento del sitio, como la elección de idioma y el almacenamiento de esta selección.'
    },
    statistics: {
      title: 'Estadísticas',
      description: 'Páginas vistas y uso del sitio, sin reconocimiento y sin almacenar la dirección IP.'
    },
    marketing: {
      title: 'Análisis y aprendizaje automático',
      description: 'Reconocimiento en visitas posteriores y análisis de la dirección IP (ubicación aproximada, operador de red, organización) y de las características del dispositivo; se conservan hasta doce meses después de la última visita. En ese proceso, su dirección IP también se transmite a registros de internet en EE. UU., Australia y Mauricio, para los que no se ha constatado un nivel adecuado de protección de datos; existe el riesgo de un acceso por parte de las autoridades de esos países y de una mayor dificultad para hacer valer sus derechos.'
    },
    acceptAll: 'Aceptar todo',
    rejectAll: 'Solo necesarias',
    settings: 'Configuración',
    save: 'Guardar selección',
    alwaysOn: 'Siempre activas'
  },
  pages: {
    teaching: {
      hero: {
        title: 'Formación en IA en el edge y EU AI Act',
        subtitle: 'Consultoría de IA para empresas • Desarrollo para el edge • Implementación conforme a la ley'
      },
      intro: 'Formación especializada en IA para la dirección, los responsables de proyecto y los equipos de desarrollo. Desde la consultoría estratégica hasta la implementación técnica, conforme al EU AI Act.',
      eu_ai_act: {
        title: 'Cumplimiento del EU AI Act y edge computing',
        subtitle: 'Implementación de IA con seguridad jurídica y procesamiento local de los datos',
        description: 'El EU AI Act establece normas estrictas para el uso de la inteligencia artificial en Europa. El edge computing ofrece la solución ideal: los datos sensibles permanecen en local, el cumplimiento normativo se simplifica y el control sobre los sistemas de IA sigue en sus manos.',
        benefits: ['Protección de datos gracias al procesamiento local', 'Menor complejidad del cumplimiento normativo', 'Control total sobre las decisiones de la IA', 'Transparencia y trazabilidad', 'Riesgos jurídicos minimizados', 'Independencia de los proveedores de nube'],
        highlight: 'Edge computing + EU AI Act = IA con seguridad jurídica y sin concesiones'
      },
      offerings: {
        title: 'Oferta formativa',
        categories: [
          { title: 'Inteligencia artificial y aprendizaje automático', icon: 'brain', topics: ['IA generativa y grandes modelos de lenguaje (edge y nube)', 'Aprendizaje automático clásico (optimizado para el edge)', 'Aprendizaje profundo y redes neuronales (despliegue en el edge)', 'Visión artificial y NLP (soluciones aptas para el edge)', 'Sistemas RAG y ajuste fino de LLM (edge y nube)', 'Agentes de IA autónomos (edge computing)', 'Cumplimiento del EU AI Act y seguridad jurídica'] },
          { title: 'Ciencia de datos y estadística', icon: 'chart', topics: ['Estadística descriptiva e inferencial', 'Modelado y análisis de datos', 'Análisis de series temporales', 'Econometría para administración de empresas y economía', 'Bioestadística para ciencias naturales', 'Pruebas A/B y diseño experimental'] },
          { title: 'Arquitectura de software y seguridad', icon: 'shield', topics: ['Arquitecturas modulares', 'Bajo acoplamiento y código limpio', 'Diseño de microservicios', 'Seguridad informática y cumplimiento normativo', 'DevOps y CI/CD', 'Arquitecturas en la nube'] }
        ]
      },
      target_groups: {
        title: 'Destinatarios',
        groups: [
          { title: 'Alta dirección y responsables de la toma de decisiones', description: 'Consultoría estratégica de IA, análisis de costes y decisiones de inversión', formats: ['Sesiones informativas para directivos', 'Análisis de ROI', 'Consultoría estratégica'], focus: 'Casos de negocio, cumplimiento del EU AI Act, planificación presupuestaria' },
          { title: 'Responsables de proyecto y gestores', description: 'Gestión de proyectos de IA, selección de tecnologías y estrategias de implementación', formats: ['Talleres de gestión', 'Evaluaciones tecnológicas', 'Elaboración de hojas de ruta'], focus: 'Planificación de proyectos, selección de proveedores, gestión de riesgos' },
          { title: 'Desarrolladores e ingenieros de TI', description: 'Desarrollo práctico de IA en el edge, implementación técnica y despliegue', formats: ['Sesiones técnicas en profundidad', 'Revisiones de código', 'Talleres de arquitectura'], focus: 'Edge computing, ajuste fino de LLM, integración de sistemas' },
          { title: 'Especialistas de las áreas de negocio', description: 'Comprensión de la IA, técnicas de formulación de prompts y aplicación práctica en el trabajo diario', formats: ['Formación de usuarios', 'Talleres sobre prompts', 'Desarrollo de casos de uso'], focus: 'Aplicación práctica, integración en los flujos de trabajo, aumento de la productividad' },
          { title: 'Estudiantes y académicos', description: 'Docencia universitaria, clases de apoyo y supervisión de proyectos académicos', formats: ['Clases magistrales', 'Tutorías', 'Supervisión de tesis'], focus: 'Estadística, econometría, métodos de investigación' }
        ]
      },
      expertise: {
        title: 'Competencias técnicas',
        items: ['Elaboración de hojas de ruta estratégicas de IA para empresas', 'Sistemas de IA en el edge con arquitecturas RAG/GRAG y ajuste fino con LoRA/QLoRA', 'Estrategias de cumplimiento del EU AI Act e implementación con seguridad jurídica', 'Análisis de ROI y planificación de inversiones para proyectos de IA', 'Agentes de IA autónomos con conjuntos de herramientas y capacidades de razonamiento', 'Gestión del cambio para la adopción de la IA en las organizaciones', 'Estrategias en la nube y en infraestructura propia (Azure, STACKIT)', 'Ingeniería de prompts y optimización de flujos de trabajo']
      },
      technologies: {
        title: 'Stack tecnológico',
        list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata'
      },
      clients: {
        title: 'Sectores e instituciones',
        sectors: ['Seguros de salud', 'Editoriales', 'Banca y fintech', 'Industria e IoT', 'Investigación y universidades', 'Consultoría', 'Empresas emergentes']
      },
      workshops: {
        title: 'Formatos disponibles',
        formats: [
          { title: 'Sesión informativa para directivos', duration: '2-4 horas', description: 'Visión estratégica de conjunto para la dirección, centrada en el ROI y en el EU AI Act' },
          { title: 'Taller de gestión', duration: '1-2 días', description: 'Formación para responsables de proyecto sobre la implementación de IA y la gestión del cambio' },
          { title: 'Sesión técnica en profundidad', duration: '2-5 días', description: 'Desarrollo práctico de IA en el edge para equipos de TI e ingenieros' },
          { title: 'Formación de usuarios', duration: '0,5-1 día', description: 'Aplicación práctica de la IA para especialistas de las áreas de negocio' },
          { title: 'Coaching individual', duration: 'Según las necesidades', description: 'Acompañamiento personal y apoyo en proyectos' }
        ]
      },
      sidebar: {
        languagesLabel: 'Idiomas:',
        languagesValue: 'DE / EN / NL',
        focusLabel: 'Enfoque:',
        specializationTitle: 'Especialización',
        specializationItems: ['IA en el edge para el procesamiento local de los datos sin dependencia de la nube', 'Implementación conforme al EU AI Act para lograr seguridad jurídica'],
        benefitsTitle: 'Ventajas',
        benefits: ['A la medida de cada grupo destinatario', 'De aplicación inmediata', 'Orientado al ROI', 'En remoto o presencial']
      },
      cta: {
        title: '¿Preparados para la transformación estratégica con IA?',
        description: 'Desde la consultoría para directivos hasta la implementación técnica: hablemos de sus necesidades concretas.',
        button: 'Solicitar asesoramiento',
        email: 'info@paioneer.eu',
        subject: 'Consulta sobre formación'
      }
    },
    agenticdev: {
      seo: {
        title: 'Intent-Driven Development (IDD) para Agentic Coding | pAIoneer Labs GmbH',
        description: 'Intent-Driven Development hace controlable el desarrollo de software asistido por IA: el significado, las decisiones y los escenarios se convierten en artefactos operativos para el Agentic Coding.',
        keywords: 'Intent-Driven Development, Intent Driven Development, IDD, Agentic Coding, desarrollo de software agéntico, desarrollo de software asistido por IA, Vibe Coding, Spec-Driven Development, ingeniería de prompts, ingeniería de requisitos con IA',
        ogTitle: 'Intent-Driven Development: el significado antes que la implementación',
        ogDescription: 'IDD operacionaliza el contexto antes de que se escriba el código: Intent, Decisions y Scenarios se convierten en la memoria del proyecto para el desarrollo de software agéntico.',
        twitterTitle: 'Intent-Driven Development (IDD) para Agentic Coding',
        twitterDescription: 'Código controlable en lugar de caos de prompts: IDD convierte el significado, las decisiones y los escenarios en artefactos operativos.',
        url: 'https://paioneer-labs.eu/agenticdev',
        structuredData: {
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: 'Intent-Driven Development (IDD) para Agentic Coding',
          serviceType: 'Desarrollo de software agéntico y procesos de desarrollo asistidos por IA',
          description: 'Consultoría e implementación de Intent-Driven Development, IDD Vaults, flujos de trabajo de Agentic Coding y desarrollo de software asistido por IA verificable.',
          provider: { '@type': 'Organization', name: 'pAIoneer Labs GmbH', url: 'https://paioneer-labs.eu' },
          areaServed: 'DE, NL, EU',
          url: 'https://paioneer-labs.eu/agenticdev'
        }
      },
      hero: { eyebrow: 'El Agentic Coding necesita contexto explícito', title: 'Intent-Driven Development', claim: 'El significado antes que la implementación.', lead: 'La IA escribe código. IDD se asegura de que trabaje en el problema correcto. Intent-Driven Development convierte los objetivos, los límites, las decisiones y los escenarios en artefactos operativos para el desarrollo de software agéntico.' },
      implicitContextProblem: { title: 'El riesgo es el contexto implícito', intro: 'El verdadero riesgo del desarrollo de software asistido por IA no es que falte código. El riesgo es el contexto que permanece oculto en la cabeza de alguien, en el historial de un chat o en tickets dispersos.', items: [{ title: 'Encargo poco claro', description: 'Los prompts suelen describir una solución, pero no el objetivo, los no objetivos, los criterios de éxito ni los supuestos. La IA trabaja entonces con rapidez, pero no necesariamente en la dirección correcta.' }, { title: 'Arquitectura accidental', description: 'Las decisiones tecnológicas se toman de pasada: la persistencia, la elección del modelo, los modos de fallo y la operación se deciden de forma implícita en lugar de dirigirse de manera consciente.' }, { title: 'Resultado no verificable', description: 'Sin escenarios ni criterios de aceptación, no queda claro si el código se comporta realmente de forma correcta o si solo parece plausible.' }], resolution: 'IDD resuelve exactamente este problema: primero se operacionaliza el significado y después se deriva de él el código.' },
      antiVibeCoding: { title: 'El Vibe Coding no es un proceso de desarrollo', description: 'Para las demos, la intuición puede bastar. No basta para un software con operación, mantenimiento, seguridad, costes y responsabilidad. Los agentes no necesitan más intuición, sino contexto explícito.', contrasts: ['El Vibe Coding genera movimiento. IDD genera dirección.', 'El prompting genera respuestas. IDD genera memoria de proyecto.', 'El Agentic Coding sin IDD se queda en actividad. El Agentic Coding con IDD se convierte en desarrollo controlable.'] },
      principle: { title: 'La documentación no es un subproducto', thesis: 'En IDD, la documentación es un artefacto operativo.', description: 'La documentación no sirve para rendir informes. Es el espacio de trabajo en el que los objetivos, los límites, las decisiones y el comportamiento esperado se hacen explícitos antes de que los agentes implementen.', pillarsTitle: 'Intent. Decisions. Scenarios. Code.', pillarsIntro: 'IDD no reduce el desarrollo de software a prompts. Hace explícito el significado de un proyecto y deriva de él una implementación verificable.', pillars: [{ title: 'Intent', description: '¿Qué se quiere lograr, qué queda expresamente fuera del alcance y cómo reconocemos el éxito?' }, { title: 'Decisions', description: '¿Qué decisiones importantes se han tomado, en qué contexto y con qué consecuencias?' }, { title: 'Scenarios', description: '¿Qué comportamiento se espera en los casos normales, los casos límite, los modos de fallo y las situaciones de aceptación?' }, { title: 'Code', description: 'La implementación surge del significado documentado y se comprueba frente a los escenarios y los pasos de verificación.' }] },
      vault: { title: 'El IDD Vault: memoria de proyecto en lugar de historial de prompts', description: 'El IDD Vault mantiene el contexto relevante allí donde agentes y personas pueden reutilizarlo. No hay más archivos de los necesarios. Cada archivo tiene una función clara.', rule: 'Pocos artefactos. Función clara. Contexto duradero.', effect: 'El Vault evita que el contexto decisivo desaparezca en el chat, en la cabeza de alguien o en tickets dispersos.', treeLines: ['/project', '  /idd_vault', '    intent.md       # objetivo, no objetivos, criterios de éxito, supuestos', '    decisions.md    # decisiones con contexto, justificación, consecuencias', '    scenarios.md    # comportamiento, casos límite, criterios de aceptación', '  /code', '  AGENTS.md         # reglas y expectativas para los agentes de código', '  README.md         # punto de entrada, instalación, modo de operación, límites'] },
      outputs: { title: 'No es texto. Es código controlable.', description: 'Los archivos de IDD no son un informe. Son la entrada para el trabajo concreto de implementación y para devolver al proyecto lo aprendido.', items: [{ file: 'intent.md', result: 'Alcance', description: 'Los endpoints, el modelo de datos, los criterios de éxito, los no objetivos y los supuestos se hacen visibles como marco del desarrollo.' }, { file: 'decisions.md', result: 'Arquitectura', description: 'La tecnología, la operación, la persistencia, la elección del modelo y los compromisos se justifican en lugar de decidirse de pasada.' }, { file: 'scenarios.md', result: 'Pruebas', description: 'Las pruebas de aceptación, los modos de fallo, las transiciones de estado y los casos límite surgen antes de la implementación o durante ella.' }, { file: 'AGENTS.md', result: 'Calidad del código', description: 'Las reglas, los patrones, las restricciones, las migraciones, OpenAPI y las salidas esperadas quedan explícitos para los agentes.' }, { file: 'README.md', result: 'Punto de entrada', description: 'La instalación, el modo de operación, los límites y los flujos de ejemplo siguen siendo comprensibles para personas y agentes.' }, { file: 'Código', result: 'Bucle de retroalimentación', description: 'Los hallazgos de la implementación y de la verificación vuelven al Vault, a las pruebas y a la siguiente iteración.' }] },
      comparison: { title: 'IDD empieza antes de la especificación', intro: 'Spec-Driven Development es sólido cuando el objetivo ya es técnicamente preciso y estable. IDD empieza antes: allí donde el dominio, los supuestos, los compromisos y los modos de fallo aún tienen que hacerse explícitos.', columns: ['Enfoque', 'Centro', 'Fortaleza', 'Límite'], rows: [{ approach: 'Prompting', center: 'Entrada para un modelo', strength: 'Rápido y directo', limit: 'Efímero, incompleto y difícil de verificar' }, { approach: 'Vibe Coding', center: 'Intuición e iteración', strength: 'Útil para experimentos y demos', limit: 'Sin un control fiable para un software del que hay que responder' }, { approach: 'Spec-Driven Development', center: 'Contrato técnico', strength: 'Coherencia con una especificación ya definida', limit: 'El problema equivocado puede implementarse de forma formalmente correcta' }, { approach: 'Intent-Driven Development', center: 'Significado, objetivo y decisiones', strength: 'Aclara el contexto, los compromisos y los límites antes de la implementación', limit: 'Exige un mantenimiento disciplinado del contexto y de la validación' }], summary: 'Las especificaciones dicen qué debe cumplirse técnicamente. IDD explica por qué debe construirse precisamente en esta dirección.' },
      workflow: { title: 'Aclarar. Decidir. Formular. Construir. Retroalimentar.', description: 'IDD no es un modelo en cascada. IDD es una iteración pequeña y controlada con contexto duradero.', steps: [{ title: 'Aclarar la intención', description: 'Los objetivos, los no objetivos, los criterios de éxito y los supuestos se hacen visibles antes de escribir código.' }, { title: 'Documentar las decisiones', description: 'Las decisiones de arquitectura y de producto se registran con su contexto, su justificación y sus consecuencias.' }, { title: 'Formular los escenarios', description: 'El comportamiento normal, los casos límite, los modos de fallo y los criterios de aceptación se describen de forma verificable.' }, { title: 'Dejar que los agentes implementen', description: 'Los agentes de IA trabajan a partir de un contexto explícito y no de prompts aislados.' }, { title: 'Verificar y retroalimentar', description: 'Los hallazgos del código, de las pruebas y de la operación actualizan el Vault y la siguiente iteración.' }] },
      impact: { title: 'Por qué esto importa en los proyectos reales', description: 'IDD hace que el desarrollo asistido por IA encaje con los equipos, la operación y el aseguramiento de la calidad.', items: ['Menos retrabajo, porque los objetivos y los no objetivos son visibles.', 'Mejor arquitectura, porque las decisiones están justificadas.', 'Mejores pruebas, porque los escenarios existen antes que el código.', 'Mejor colaboración, porque el contexto no desaparece en el chat.', 'Mejores resultados de los agentes, porque cada paso se basa en artefactos explícitos.'] },
      contact: { title: 'Llevar IDD a los procesos de desarrollo agéntico', description: 'Si el desarrollo asistido por IA ha de ser algo más que experimentación, necesita un modelo operativo de contexto.', details: 'Ayudamos a crear IDD Vaults, reglas para agentes, escenarios y flujos de trabajo de desarrollo verificables.', button: 'Hablar sobre IDD', subject: 'Hablar sobre Intent-Driven Development', email: 'info@paioneer.eu' }
    },
    impressum: injectPersonalData('es', baseTranslationES)
  }
};
